import imgUrl from "@/utils/imgUrl"

const productList = [
  {
    type: '气体传感器',
    id: "0",
    data: [
      {
      //   id: "001",
      //   name: "新型纳米气体传感器",
      //   dec: "新型纳米气体传感器",
      //   imgUrl: "Nano-gas-sensor.png",
      //   detail: [
      //     {
      //       name: "介绍",
      //       text: [
      //         "功耗远低于市面上的金属氧化物气体传感器, 同时保持了媲美电化学气体传感器的高灵敏度；阵列传感器可实现多种气体的同时监测,"
      //         +"克服了传统传感器选择性低与易受干扰性气体及温湿度影响的缺点, 极大降低现有气体传感器的成本。"]
      //     }
      //   ]
      // },  {
        id: "002",
        name: "小量程氢气传感器",
        dec: "小量程氢气传感器",
        imgUrl: "sensor-H2.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=1026831897026&mi_id=0000xaRiqPbwgdm5ZMew47X06GMtY0Ew9fomm0CqaiIiKkU&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-5A"
            ]
          }, {
            name: "介绍",
            text: [
              "这是一款高灵敏的小量程氢气传感器，基于NBHive®和NHC-nose®生产工艺，在三维纳米蜂巢的高比表面积模板上沉积特定金属氧化物和贵金属颗粒而制得，能实现ppb级精准检测。具备低功耗、高选择性、快速响应、寿命长、小型化等优势，"+
              "适用于氢能安全、工业监测等多种场景，为氢气泄漏提供可靠预警。"
            ]
          }
        ],
        detail: [
          {
            name: "产品规格",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "加热器电压(VH)", "数值":"参考电压 3.3V(可定制)"},
                {"参数名称": "加热器功耗", "数值":"170 ± 10 mW"},
                {"参数名称": "加热器电阻(Rheater)", "数值":"34 ± 4 Ω"},
                {"参数名称": "洁净空气电阻(R0)", "数值":"100 KΩ ~ 1000 KΩ"},
                {"参数名称": "检测浓度范围", "数值":"10 ppm ~ 200 ppm"},
                {"参数名称": "检测下限", "数值":"10 ppm"},
                {"参数名称": "标准测试条件", "数值":"温湿度：25 ± 5 °C、60 ± 5% RH"},
                {"参数名称": "响应时间", "数值":"< 7s"},
                {"参数名称": "保存条件", "数值":"洁净空气密封或真空密封"}
              ]
            }
          }, {
            name: "气体选择性",
            text: [
              "传感器对不同气体的灵敏度曲线。Y 轴是传感器在不同气体中响应电阻 Rs 与浓度值为"
                  +"200ppm 氢气下测得的响应电阻Rw 的比值，即归一化 N 值。"
            ],
            imgUrl: "h2_small_select.png"
          }, {
            name: "器件恢复",
            text: ["如图所示为气体响应和气体重复性"],
            imgUrl: "h2_small_recover.png"
          }
        ]
      },  {
        id: "003",
        name: "大量程氢气传感器",
        dec: "大量程氢气传感器",
        imgUrl: "sensor-H2.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5B_大量程氢气传感器_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=935424164362&mi_id=0000XTDQX90Ung-EZCuj56A6AI9-4Z-T0yQ1l7bV3ItyC0Q&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-5B"
            ]
          }, {
            name: "介绍",
            text: [
              "这是一款高灵敏的大量程氢气传感器，基于NBHive®和NHC-nose®生产工艺，在三维纳米蜂巢的高比表面积模板上沉积特定金属氧化物和贵金属颗粒而制得，能实现ppb级精准检测。具备低功耗、高选择性、快速响应、寿命长、小型化等优势，适用于氢能安全、工业监测等多种场景，为氢气泄漏提供可靠预警。"
            ]
          }
        ],
        detail:[
          {
            name: "产品规格",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "加热器电压(VH)", "数值":"参考电压 3.3V(可定制)"},
                {"参数名称": "加热器功耗", "数值":"170 ± 10 mW"},
                {"参数名称": "加热器电阻(Rheater)", "数值":"34 ± 4 Ω"},
                {"参数名称": "洁净空气电阻(R0)", "数值":"100 KΩ ~ 1000 KΩ"},
                {"参数名称": "检测浓度范围", "数值":"500 ppm ~ 10000 ppm"},
                {"参数名称": "检测下限", "数值":"10 ppm"},
                {"参数名称": "标准测试条件", "数值":"温湿度：25 ± 5 °C、60 ± 5% RH"},
                {"参数名称": "响应时间", "数值":"< 7s"},
                {"参数名称": "保存条件", "数值":"洁净空气密封或真空密封"}
              ]
            }
          }, {
            name: "气体选择性",
            text: [
              "传感器对不同气体的灵敏度曲线。Y 轴是传感器在不同气体中响应电阻 Rs 与浓度值为"
                  +"4000 ppm氢 氢气下测得的响应电阻Rw 的比值，即归一化 N 值。"
            ],
            imgUrl: "h2_big_select.png"
          }, {
            name: "器件恢复",
            text: ["如图所示传感器在遇到氢气气体时迅速响应，当排走氢气气体时，传感器在短时间内恢复至初始值。Y 轴是传感器在 "+
            "4000 ppm 氢气气体中的响应电阻值 Rs。如图 2-5 所示传感器在 4000 ppm 氢气气体中重复测试的响应变化。"],
            imgUrl: "h2_big_recover.png"
          }
        ]
      },  {
        id: "004",
        name: "TVOC传感器",
        dec: "TVOC传感器",
        imgUrl: "sensor-TVOC.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_NHC-1_TVOC传感器_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934350130859&mi_id=0000r3BO0TcSKUyj_pzsjit1xOB8Uk6Pt2TYiPq6voHXvGI&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-1"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技TVOC传感器，采用自主独创的纳米蜂巢（NHC）第三代半导体传感技术，为空气环境中的TVOC(总挥发性有机化合物)气体浓度提供高精度、高稳定检测。产品体积小巧、功耗低，可轻松集成在智能家居、新风系统及工业设备中。抗干扰能力强、超长寿命，为您实时捕捉空气中TVOC浓度变化，助力构筑家庭健康、工业安全的智能防线。"
            ]
          }
        ],
        detail: [
          {
            name: "产品规格",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "加热器电压", "数值":"3.3 ± 0.1 V"},
                {"参数名称": "加热器功耗", "数值":"160 ± 10 mW"},
                {"参数名称": "加热器电阻", "数值":"35 ± 4 Ω"},
                {"参数名称": "洁净空气电阻", "数值":"10 KΩ ~ 500 KΩ"},
                {"参数名称": "检测浓度范围", "数值":"0.1 ppm ~ 100 ppm"},
                {"参数名称": "检测下限", "数值":"10 ppb"},
                {"参数名称": "标准测试条件", "数值":"温湿度：25 ± 5 °C、60 ± 5% RH"},
                {"参数名称": "响应时间", "数值":"< 20s"},
                {"参数名称": "保存条件", "数值":"洁净空气密封或真空密封"}
              ]
            }
          }, {
            name: "气体选择性",
            text: [
              "如图为传感器对不同气体的灵敏度曲线。Y 轴是传感器在不同气体中的响应大小 S。"
              +"(曲线是在标准测试条件下测试的，其中温度是 25 ± 5 °C，湿度是 60 ± 5% RH。)"
            ],
            imgUrl: "tvoc_select.png"
          }, {
            name: "器件恢复",
            text: ["传感器对不同气体的响应恢复"],
            imgUrl: "tvoc_recover.png"
          }, {
            name: "",
            text: [
              "如图所示传感器在 10 ppm乙醇气体中重复测试的响应变化。通过多次测试传感器在 10 ppm乙醇"
              +"气体中的响应与恢复过程，以此来表现传感器的重复性。Rs 是传感器的实时响应电阻，"
              +"Y 轴是以传感器在洁净空气中的基线电阻 Ro 为参考，传感器实时电阻的归一化结果。"
            ],
            imgUrl: "tvoc_recover2.png"
          }, {
            name: "长期稳定性",
            text: [
              "传感器经过 60 天以上的长期跟踪，长期稳定性表现如图所示。如图 2-7 所示传感器在洁净空气中电阻的变化，"
              +"首先将传感器置于洁净空气中通电，然后在标准测试条件下对传感器进行长期稳定性测试。"
              +"如图 2-8 所示传感器在 10 ppm 乙醇气体中响应电阻的变化，Y 轴是传感器在 10 ppm乙醇气体中的响应大小 S。"
            ],
            imgUrl: "tvoc_steady.png"
          }
        ]
        },  {
        id: "005",
        name: "乙醇传感器",
        dec: "乙醇传感器",
        imgUrl: "sensor-C2H5OH.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_NHC-3_乙醇传感器_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934920513737&mi_id=0000jvM4kT5X0v3k0QdmNIe-yA1OSzEjamDMbLrTsgcvIGA&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-3"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技乙醇传感器采用自主研发的纳米蜂巢（NHC）第三代半导体传感技术，基于NBHive®和NHC-nose®生产工艺，灵敏度高、响应迅速、抗干扰能力强。可精准检测环境中乙醇浓度，检测浓度范围0.1 ppm ~ 100 ppm，检测下限10 ppb。广泛应用于工业安全、酿酒厂、实验室等场景，支持自动校准、数据存储及多信号输出，搭配智能报警系统，有效保障生产与生活安全。"
            ]
          }
        ],
        detail: [
          {
            name: "产品规格",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "加热器电压", "数值":"3.3 ± 0.1 V"},
                {"参数名称": "加热器功耗", "数值":"160 ± 10 mW"},
                {"参数名称": "加热器电阻", "数值":"35 ± 4 Ω"},
                {"参数名称": "洁净空气电阻", "数值":"10 KΩ ~ 500 KΩ"},
                {"参数名称": "检测浓度范围", "数值":"0.1 ppm ~ 100 ppm"},
                {"参数名称": "检测下限", "数值":"10 ppb"},
                {"参数名称": "标准测试条件", "数值":"温湿度：25 ± 5 °C、60 ± 5% RH"},
                {"参数名称": "响应时间", "数值":"< 20s"},
                {"参数名称": "保存条件", "数值":"洁净空气密封或真空密封"}
              ]
            }
          }, {
            name: "气体选择性",
            text: [
              "如图为传感器对不同气体的灵敏度曲线。Y 轴是传感器在不同气体中的响应大小 S。"
              +"(曲线是在标准测试条件下测试的，其中温度是 25 ± 5 °C，湿度是 60 ± 5% RH。)"
            ],
            imgUrl: "c2h5oh_select.png"
          }, {
            name: "器件恢复",
            text: [
              "如图为传感器对不同气体的响应及恢复过程，Y 轴是传感器在不同气体中的响应大小 S。"
              +"传感器对各种气体响应迅速，当排走气体时，传感器在短时间内恢复至初始值。"
            ],
            imgUrl: "c2h5oh_recover.png"
          }, {
            name: "",
            text: [
              "如图所示传感器在 10 ppm乙醇气体中重复测试的响应变化。通过多次测试传感器在 10 ppm乙醇"
              +"气体中的响应与恢复过程，以此来表现传感器的重复性。Rs 是传感器的实时响应电阻，"
              +"Y 轴是以传感器在洁净空气中的基线电阻 Ro 为参考，传感器实时电阻的归一化结果。"
            ],
            imgUrl: "c2h5oh_recover2.png"
          }, {
            name: "长期稳定性",
            text: [
              "传感器经过 60 天以上的长期跟踪，长期稳定性表现如图所示。如图 2-7 所示传感器在洁净空气中电阻的变化，"
              +"首先将传感器置于洁净空气中通电，然后在标准测试条件下对传感器进行长期稳定性测试。"
              +"如图 2-8 所示传感器在 10 ppm 乙醇气体中响应电阻的变化，Y 轴是传感器在 10 ppm乙醇气体中的响应大小 S。"
            ],
            imgUrl: "c2h5oh_steady.png"
          }
        ] 
      },  {
        id: "006",
        name: "硫化氢传感器",
        dec: "硫化氢传感器",
        imgUrl: "sensor-H2S.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_NHC-4_硫化氢传感器_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934918261534&mi_id=0000i6mY024fGfR1a_97nACex7ba8Bu3VAM5_w03bgxVWSA&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-4"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技硫化氢传感器，专为智能护理与安全监测设计。采用我们全程自主研发的第三代纳米蜂巢半导体技术，可精准捕捉ppb级硫化氢浓度变化，灵敏度高，响应迅速。广泛应用于智能纸尿裤、工业安防及环境监测等领域，精准实现排泄识别与健康预警。产品具备抗干扰、低功耗、长寿命等优势，搭配智能算法，确保数据科学可靠。"
            ]
          }
        ],
        detail: [
          {
            name: "产品规格",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "加热器电压", "数值":"2.5 ± 0.1 V"},
                {"参数名称": "加热器功耗", "数值":"120 ± 10 mW"},
                {"参数名称": "加热器电阻", "数值":"35 ± 4 Ω"},
                {"参数名称": "洁净空气电阻", "数值":"200 KΩ ~ 1000 KΩ"},
                {"参数名称": "检测浓度范围", "数值":"0.1 ppm ~ 20 ppm"},
                {"参数名称": "检测下限", "数值":"0.1 ppm"},
                {"参数名称": "标准测试条件", "数值":"温湿度：25 ± 5 °C、60 ± 5% RH"},
                {"参数名称": "响应时间", "数值":"< 20s"},
                {"参数名称": "保存条件", "数值":"洁净空气密封或真空密封"}
              ]
            }
          }, {
            name: "气体选择性",
            text: [
              "如图为传感器对不同气体的灵敏度曲线。Y 轴是传感器在不同气体中的响应大小 S。"
              +"(曲线是在标准测试条件下测试的，其中温度是 25 ± 5 °C，湿度是 60 ± 5% RH。)"
            ],
            imgUrl: "h2s_select.png"
          }, {
            name: "器件恢复",
            text: [
              "如图为传感器对不同气体的响应及恢复过程，Y 轴是传感器在不同气体中的响应大小 S。"
              +"传感器对各种气体响应迅速，当排走气体时，传感器在短时间内恢复至初始值。"
            ],
            imgUrl: "h2s_recover.png"
          }, {
            name: "长期稳定性",
            text: [
              "传感器经过180天以上的长期跟踪，长期稳定性表现如图所示。如图所示传感器在洁净空气中电阻的变化，"
              +"首先将传感器置于洁净空气中通电，然后在标准测试条件下对传感器进行长期稳定性测试。"
              +"如图所示传感器在10ppm硫化氢气体中响应电阻的变化，Y 轴是传感器在10 ppm硫化氢气体中的响应电阻Rs。"
            ],
            imgUrl: "h2s_steady.png"
          }
        ] 
      },  {
        id: "007",
        name: "甲烷传感器",
        dec: "甲烷传感器",
        imgUrl: "sensor-CH4.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_NHC-2_甲烷传感器_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934348854629&mi_id=0000KzaW7RRLF7zg3lqc_E8__90_hYkU7YseJVNwn4vI3fM&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-2"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技甲烷传感器，基于NBHive®和NHC-nose®生产工艺，通过在三维纳米蜂巢的高比表面积模板上沉积特定金属氧化物和贵金属颗粒而制得。产品体积小、功耗低、灵敏度高，可精准探测微量甲烷浓度，响应迅速且稳定性强。产品易于集成，广泛适用于智慧家居、工业安全、能源管理等领域，助力构建智能、安全的用气环境。"
            ]
          }
        ],
        detail: [
          {
            name: "产品规格",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "加热器电压(VH)", "数值":"参考电压 3.3V(可定制)"},
                {"参数名称": "加热器功耗", "数值":"170 ± 10 mW"},
                {"参数名称": "加热器电阻(Rheater)", "数值":"34 ± 4 Ω"},
                {"参数名称": "洁净空气电阻(R0)", "数值":"100 KΩ ~ 1000 KΩ"},
                {"参数名称": "检测浓度范围", "数值":"10 ppm ~ 10000 ppm"},
                {"参数名称": "检测下限", "数值":"10 ppm"},
                {"参数名称": "标准测试条件", "数值":"温湿度：25 ± 5 °C、60 ± 5% RH"},
                {"参数名称": "响应时间", "数值":"< 7s"},
                {"参数名称": "保存条件", "数值":"洁净空气密封或真空密封"}
              ]
            }
          }, {
            name: "气体选择性",
            text: [
              "如图所示传感器对不同气体的灵敏度曲线。Y 轴是传感器在不同气体中响应电阻 Rs 与浓度值"
              +"为5000 ppm甲烷下测得的响应电阻Rw 的比值，即归一化 N 值。"
            ],
            imgUrl: "ch4_select.png"
          }, {
            name: "",
            text: [
              "根据家用可燃气体探测器《GB15322.2-2019》文件要求，将甲烷传感器分别置于6000 ppm乙酸气体、"
              +"2000ppm乙醇气体环境中，测试其响应情况。如图2-11所示在标准测试条件下依次注入5000ppm甲烷气"
              +"体与2000ppm乙醇气体，传感器的响应电阻值曲线。Y轴是传感器的响应电阻Rs。"
            ],
            imgUrl: "ch4_select2.png"
          }, {
            name: "",
            text: [
              "如图在标准测试条件下依次注入5000ppm甲烷气体与6000ppm乙酸气体，"
              +"传感器的响应电阻值曲线。Y轴是传感器的响应电阻Rs。"
            ],
            imgUrl: "ch4_select3.png"
          }, {
            name: "器件恢复",
            text: [
              "如图 2-5 所示传感器在遇到甲烷气体时迅速响应，当排走甲烷气体时，传感器在短时间内恢复至初始值。"
              +"Y 轴是传感器在 5000 ppm 甲烷气体中的响应电阻值 Rs。如图 2-6 所示传感器在 5000 ppm 甲烷气体中重复测试的响应变化。"
            ],
            imgUrl: "ch4_recover.png"
          }, {
            name: "长期稳定性",
            text: [
              "如图所示传感器经过 180 天以上测试的长期稳定性数据。首先，传感器在洁净空气下连续工作至少"
              +"48h后，将其置于标准测试条件下进行测试，Y 轴是传感器在5000ppm甲烷、2000ppm乙醇、洁净空气中"
              +"的响应电阻 Rs。传感器对甲烷的响应非常稳定，对乙醇的抗干扰效果良好且稳定。"
            ],
            imgUrl: "ch4_steady.png"
          }
        ] 
      }
    ]
  }, {
    type: '气体传感器模组',
    id: "1",
    data: [
      {
        id: "011",
        name: "TVOC气体传感器模组",
        dec: "TVOC气体传感器模组",
        imgUrl: "AGM.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_AGM-1_TVOC传感器模组_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=933933883418&mi_id=0000vm9gNsEysLzRtLyAM1Y_iZt0DPa9i1a1fsJjUK8mz18&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "AGM-1"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技TVOC气体传感器模组，采用独创自研的纳米蜂巢（NHC）第三代半导体传感技术，高精度、高稳定监测空气中的TVOC（总挥发性有机物）气体浓度。模组体积小巧、功耗低、分辨率高，抗干扰能力强，广泛适用于智能家居、工业安防及环境监测等领域。产品能根据用户特定需求进行个性化定制，灵活满足各类集成需求，是构建智慧空气解决方案的理想核心部件。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            text: [
              "1. 智能家居：为家庭提供实时空气质量监测，确保居住环境的健康舒适。",
              "2. 环境空气质量监测：在户外或特定区域进行空气质量的持续监测，以评估和改善环境状况。",
              "3. 车载空气净合器：在汽车内监测和净合空气，保障驾驶和乘坐人员的健康。",
              "4. 畜牧养殖空气检测：监测养殖场内空气质量，为动)提供更好的生长环境。",
              "5. 手持空气质量检测仪：便携式设备，方便用户随时随地检测空气质量。",
              "6. 工厂车间新风系统：在工业环境中监测空气质量，通过新风系统改善通风条件。"
            ]
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"AGM-1"},
                {"参数名称": "物理接口", "数值":"2.0MM*6P 排针"},
                {"参数名称": "检测气体", "数值":"TVOC"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤60mA"},
                {"参数名称": "通信接口", "数值":"UART"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "储存温度", "数值":"-25℃～65℃"},
                {"参数名称": "储存湿度", "数值":"≤65％RH"},
                {"参数名称": "外形尺寸", "数值":"20.5×16.5×3.6mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤20g"},
                {"参数名称": "使用寿命", "数值":"5 年"}
              ]
            }
          },
        ]
      },  {
        id: "012",
        name: "甲烷气体传感器模组",
        dec: "甲烷气体传感器模组",
        imgUrl: "AGM.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_AGM-2_甲烷传感器模组_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934917077894&mi_id=0000-YSinpV6atzhEg25HW7nOvJTfBXTj48azhK1BGNgwnM&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "AGM-2"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技甲烷气体传感器模组，采用自研的NBHive®和NHC-nose®生产工艺，具备高灵敏度、低功耗、小型化优势，可精准检测天然气（CH4）浓度，广泛应用于工业安全、智慧家居、能源管理等领域。模组支持RS485、LoRaWAN等多种通信方式，易集成，性能稳定可靠。还可根据客户需求提供定制化服务，灵活适配各类应用场景，助力实现智能化气体监测与管理。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            text: [
              "1. 家庭安全：实时监测燃气灶具、燃气壁挂炉及燃气管道等家用燃气系统的甲烷泄漏情况，"
              +"为家庭提供全天候的甲烷气体浓度监测，全面保障居住环境的安全。",
              "2. 餐饮业甲烷风险监测：适用于商用厨房中燃气设备(如炉灶等)的甲烷浓度监测，有效预防火灾事故，"
              +"保障人员与财产安全，同时为评估餐厅环境状况提供数据支持，并作为环境优化与风险防控的重要依据。",
              "3. 工业甲烷检测：适用于沼气池、垃圾填埋场等工业场景的甲烷气体检测，有效预防因甲烷燃烧引发的工业事故，"
              +"为安全生产提供可靠保障。"
            ]
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"AGM-2"},
                {"参数名称": "物理接口", "数值":"2.0MM*6P排针"},
                {"参数名称": "检测气体", "数值":"CH4"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤60mA"},
                {"参数名称": "通信接口", "数值":"UART"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "储存温度", "数值":"-25℃～65℃"},
                {"参数名称": "储存湿度", "数值":"≤65％RH"},
                {"参数名称": "外形尺寸", "数值":"20.5×16.5×3.6mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤20g"},
                {"参数名称": "使用寿命", "数值":"5 年"}
              ]
            }
          },
        ]
      },  {
        id: "013",
        name: "乙醇气体传感器模组",
        dec: "乙醇气体传感器模组",
        imgUrl: "AGM.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_AGM-3_乙醇传感器模组_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934352810029&mi_id=00007WkH2QkGQRh4F3fxcDlQ-or1eYzqeXHENvYL8Bz9K7U&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "AGM-3"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技乙醇气体传感器模组，基于自研的NBHive®和NHC-nose®生产工艺，具备高灵敏度、强抗干扰及快速响应特性。精准识乙醇气体，稳定性优异。支持多场景定制，广泛适用于食品安全、执法酒精测试、工业安全、智慧家居等。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            text: [
              "1. 执法领域酒精测试：可集成于便携式酒精测试仪，用于交警现场执法，快速准确检测驾驶员呼气中的酒精浓度，"
              +"为执法提供可靠依据；或是用于酒吧、餐厅等场所的酒精浓度监测，预防因过度饮酒引发的治安事件。",
              "2. 食品生产发酵监控：可用于实时监测发酵罐内的乙醇浓度，实现对发酵过程的良好控制，优化发酵工艺，提高产品质量和产量。",
              "3. 工业生产、储运及排放检测：在制药、化工、食品饮料等工业生产中，实时监测乙醇浓度有助于确保工艺参数稳定，"
              +"优化生产效率并提升产品质量；同时，该监测也可作为储运与排放过程中甲烷泄漏的检测依据。"
            ]
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"AGM-3"},
                {"参数名称": "物理接口", "数值":"2.0MM*6P排针"},
                {"参数名称": "检测气体", "数值":"C2H5OH"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤60mA"},
                {"参数名称": "通信接口", "数值":"UART"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "储存温度", "数值":"-25℃～65℃"},
                {"参数名称": "储存湿度", "数值":"≤65％RH"},
                {"参数名称": "外形尺寸", "数值":"20.5×16.5×3.6mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤20g"},
                {"参数名称": "使用寿命", "数值":"5年"}
              ]
            }
          },
        ]
      },  {
        id: "014",
        name: "硫化氢气体传感器模组",
        dec: "硫化氢气体传感器模组",
        imgUrl: "AGM.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_AGM-4_硫化氢传感器模组_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=935422376733&mi_id=0000FTRsENMW0y3SvOWWIfWIwjb4bTAbz46rp7qPMuXotHQ&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "AGM-4"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技硫化氢（H₂S）气体传感器模组，基于“纳米蜂巢（NHC）”第三代半导体技术，具备高灵敏度、强抗干扰与低功耗优势。模组可精准检测ppb级硫化氢浓度，响应快、稳定性高。提供量程、精度、输出方式等全方位定制服务，灵活适配工业安全、环保监测、智慧环卫等多元场景，是气体监测领域可信赖的核心传感解决方案。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            text: [
              "1. 环境监测：实时监测城市空气、工业区周边、垃圾填埋场等环境中的硫化氢浓度，评估空气质量以及当地污染状况，预警潜在危害并指导生态修复。",
              "2. 污水处理：监测污水处理厂与污水管网的进水口、曝气池、污泥处理等环节的硫化氢浓度，优化处理工艺，提高处理效率，"
              +"预警管道腐蚀和堵塞风险，保障设备安全运行。",
              "3. 矿业监测：监测煤矿、金属矿等矿井下的硫化氢浓度，预警瓦斯爆炸和硫化氢中毒风险，保障矿工生命安全。",
              "4. 工业监测：实时监测炼油厂、化工厂等生产环境中的硫化氢浓度，及时预警泄漏风险，确保生产安全；"
              +"同时，天然气产业可通过该传感器监测净化过程中的硫化氢浓度，有效控制产品质量，保障运输安全。",
              "5. 科研实验: 可用于实验室中硫化氢气体的检测和分析。"
            ]
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"AGM-4"},
                {"参数名称": "物理接口", "数值":"2.0MM*6P排针"},
                {"参数名称": "检测气体", "数值":"H2S"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤60mA"},
                {"参数名称": "通信接口", "数值":"UART"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "储存温度", "数值":"-25℃～65℃"},
                {"参数名称": "储存湿度", "数值":"≤65％RH"},
                {"参数名称": "外形尺寸", "数值":"20.5×16.5×3.6mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤20g"},
                {"参数名称": "使用寿命", "数值":"5年"}
              ]
            }
          },
        ]
      },  {
        id: "015",
        name: "氢气气体传感器模组",
        dec: "氢气气体传感器模组",
        imgUrl: "AGM.png",
        href: "https://www.aisensing.cn/PDF/艾感科技_AGM-5_氢气传感器模组_技术手册_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934917909970&mi_id=0000e66LMsGfIUog4toEVOwiR5dU1k0Rw2coaZrAqjq7OLo&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "AGM-5"
            ]
          }, {
            name: "介绍",
            text: [
              "艾感科技氢气传感器模组，专门设计用于精确测量环境中的H2气体浓度。它采用自研基于“纳米蜂巢（NHC）”第三代半导体技术，具备高灵敏、长寿命、小型化优势，为空气质量和工业安全的评估提供了一种高效工具。支持量程、接口、外形等个性化定制，适配工业、能源、环境、化工等多元场景，实现安全高效监测。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            text: [
              "1. 能源与燃料电池：能够精准检测氢气泄漏，保障氢气使用过程中的安全性；可对燃料电池性能进行实时监测，"
              +"助力燃料电池高效稳定运行；还能对生物燃气成分展开分析，为生物能源的合理利用提供有力的数据支撑。",
              "2. 化学工业：于化工生产过程中，它如同 “智能管家”，密切监控生产环节，确保化学反应按预期进行；"
              +"在化工废气排放方面，可实现对废气的实时监测，严格把控排放指标，助力环保达标；在化工仓储区域，"
              +"它担当安全 “卫士”，监测可燃与有毒气体浓度，有效预防火灾、爆炸及中毒事故的发生。",
              "3. 环境监测：在空气质量监测方面，它是获取空气质量数据的关键设备，为环境质量评估提供可靠依据；针对工业污染源，能够精准监测企业废气排"
              +"放，助力环保部门强化监管；在室内环境监测中，可检测甲醛、苯、二氧化碳等有害气体，守护人们的室内健康环境。"
            ]
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"AGM-5"},
                {"参数名称": "物理接口", "数值":"2.0MM*6P排针"},
                {"参数名称": "检测气体", "数值":"H2"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤60mA"},
                {"参数名称": "通信接口", "数值":"UART"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "储存温度", "数值":"-25℃～65℃"},
                {"参数名称": "储存湿度", "数值":"≤65％RH"},
                {"参数名称": "外形尺寸", "数值":"20.5×16.5×3.6mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤20g"},
                {"参数名称": "使用寿命", "数值":"5年"}
              ]
            }
          },
        ]
      }
    ]
  }, {
    type: '嗅觉芯片',
    id: "2",
    data: [
      {
        id: "021",
        name: "四阵列电子鼻模组",
        dec: "四阵列电子鼻模组",
        imgUrl: "fourleaf.png",
        href: "https://www.aisensing.cn/PDF/四阵列电子鼻模组技术说明书_V1.2(1).pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=934508504481&mi_id=0000tUGIivRTT5mo1dOi58xNu71g6aUg9ZY3__U74F7OJLo&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-EN-4"
            ]
          }, {
            name: "介绍",
            text: [
              "四节点电子鼻模组是基于艾感科技自研自产的单气体传感器组成的分立式嗅觉识别功能模组。其中气体传感器是电子嗅觉系统的关键组成单元，由4个具有广谱响应特征、交叉灵敏度大、 对不同气味有不同灵敏度的气体传感器组成。结合上位机软件和智能识别算法，并通过预训练的发方式，可以实现4种以上不同气味的识别，广泛适用于智能家居、工业安防、新能源汽车、储能安全及环境监测等领域。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            table: {
              header: ["应用场景", "可以识别的特征气体"],
              body: [
                {"应用场景": "室内空气质量", "可以识别的特征气体":"甲醛、甲苯、乙苯等 TVOC"},
                {"应用场景": "室外大气监测", "可以识别的特征气体":"TVOC、二氧化硫、氮氧化物等"},
                {"应用场景": "危险气体检测", "可以识别的特征气体":"甲烷、氢气、一氧化碳等"},
                {"应用场景": "臭气检测", "可以识别的特征气体":"氨气、硫化氢、乙硫醇等"}
              ]
            }
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"四阵列电子鼻模组"},
                {"参数名称": "物理接口", "数值":"GH1.25 4Pin"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤150mA"},
                {"参数名称": "输出数据类型", "数值":"UART(TTL)"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "外形尺寸", "数值":"50×23×7.2mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤10g"}
              ]
            }
          },
        ]
      },  {
        id: "022",
        name: "九阵列电子鼻模组",
        dec: "九阵列电子鼻模组",
        imgUrl: "fourleaf2.png",
        href: "https://www.aisensing.cn/PDF/九阵列电子鼻模组技术说明书_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=931233327881&mi_id=0000Zl1upzR_Pr2-quvdDRuITtdo5eGZpVUMhlAdryyOnN4&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-EN-9"
            ]
          }, {
            name: "介绍",
            text: [
              "九节点电子鼻模组是基于艾感科技自研自产的单气体传感器组成的分立式嗅觉识别功能模组。其中气体传感器是电子嗅觉系统的关键组成单元，由9个具有广谱响应特征、交叉灵敏度大、 对不同气味有不同灵敏度的气体传感器组成。结合上位机软件和智能识别算法，并通过预训练的发方式，可以实现多种不同气味的识别。广泛适用于智能家居、工业安防、新能源汽车、储能安全及环境监测等领域。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            table: {
              header: ["应用场景", "可以识别的特征气体"],
              body: [
                {"应用场景": "室内空气质量", "可以识别的特征气体":"甲醛、甲苯、乙苯等 TVOC"},
                {"应用场景": "室外大气监测", "可以识别的特征气体":"TVOC、二氧化硫、氮氧化物、CO等"},
                {"应用场景": "危险气体检测", "可以识别的特征气体":"甲烷、氢气、一氧化碳、乙烷、丙烷等"},
                {"应用场景": "臭气检测", "可以识别的特征气体":"氨气、硫化氢、甲硫醇、乙硫醇、三甲胺等"},
                {"应用场景": "食物新鲜度检测", "可以识别的特征气体":"TVOC、硫化物、氨气、甲烷、乙烯、乙酸、乙醇、甲硫醇。"},
                {"应用场景": "花香、水果辨别", "可以识别的特征气体":"各类 TVOC(单萜醇、苯乙醇、苯甲酸酯类等)"}
              ]
            }
          }, {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"九阵列电子鼻模组"},
                {"参数名称": "物理接口", "数值":"Type-C"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤500mA"},
                {"参数名称": "输出数据类型", "数值":"UART(TTL)"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "外形尺寸", "数值":"45×35×6.64mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤10g"}
              ]
            }
          },
        ]
      },  {
        id: "023",
        name: "四味獾模组",
        dec: "四味獾模组",
        imgUrl: "fourleafMozu.png",
        // href: "https://www.aisensing.cn/PDF/九阵列电子鼻模组技术说明书_V1.1.pdf",
        taobaoHref: "https://item.taobao.com/item.htm?id=1027674120061&mi_id=0000yaf6qvmApeSl2njB_BMmA8Vz1vsQfQV3PbbIF7t6kdQ&spm=a21xtw.29178619.0.0&xxc=shop",
        introduction: [
          {
            name: "型号",
            text: [
              "NHC-OLF-4"
            ]
          }, {
            name: "介绍",
            text: [
              "四味獾嗅觉模组（2×2阵列）是基于艾感科技自研自产的四像素气体传感器阵列开发的微型化集成式嗅觉功能模组。其中气体传感器阵列芯片是电子嗅觉系统的关键组成单元，由具有广谱响应特征、交叉灵敏度大、 对不同气味有不同灵敏度的气敏元件组成，在长期运行中保持一致的性能，体积紧凑使易集成到各种设备。广泛适用于智能家居、工业安防、新能源汽车、储能安全及环境监测等领域。"
            ]
          }
        ],
        detail: [
          {
            name: "技术参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "型号", "数值":"四叶草模组（2×2阵列）"},
                {"参数名称": "物理接口", "数值":"2.0mm * 6P排针"},
                {"参数名称": "工作电压", "数值":"5.0±0.2V DC(无电压反接保护)"},
                {"参数名称": "工作电流", "数值":"≤75mA"},
                {"参数名称": "输出数据类型", "数值":"UART"},
                {"参数名称": "工作温度", "数值":"-20℃～50℃"},
                {"参数名称": "工作湿度", "数值":"≤96％RH"},
                {"参数名称": "外形尺寸", "数值":"23×29×3.3mm(L×W×H)"},
                {"参数名称": "重量", "数值":"≤30g"}
              ]
            }
          },
        ]
      }
    ]
  }, {
    type: "监测系统",
    id: "3",
    data: [
      {
        id: "031",
        name: "空气质量小程序",
        dec: "空气质量小程序",
        imgUrl: "miniprogram-AQMS.png",
        introduction: [
          {
            name: "介绍",
            text: [
              "通过微信小程序,可随时通过小程序快速获得已有基站当前的大气质量数据和历史数据。小程序可生产各种趋势和对比,方便用户进行快速分析和判断。当监测数据超出预设条件时,小程序会自动发送预警信息到授权客户的微信上,用户不再需要人工持续监测数据,从而将用户解放出来,降低工作符合。"
            ]
          }
        ],
        detail: [
          {
            name: "使用",
            table: {
              header: ["参数", "数值"],
              body: [
                {"参数": "操作系统", "数值":"Android，HarmonyOS 4.X及其旧版本和IOS"},
                {"参数": "微信版本", "数值":"8.0.49及以上"},
                {"参数": "网络", "数值":"WIFI/4G"},
                {"参数": "客户权限", "数值":"蓝牙, 定位"},
              ]
            }
          }
        ]
      },  {
        id: "032",
        name: "气体监测小程序",
        dec: "气体监测小程序",
        imgUrl: "wx-gas.png",
        introduction: [
          {
            name: "介绍",
            text: [
              "艾感科技自主研发的气体监测小程序，是一款可以通过连接蓝牙查找不同气体监测数据的系统。它可以把设备监测到的各类气体传感器数据实时同步上传、存储到服务器云端集中管理，支持用户在在多种不同场景的情况下，使用不同的设备型号进行远程查看。",
              "这款小程序还具备超标自动预警、历史数据追溯、报表导出等功能，可按行业需求定制界面、监测指标与管理权限，广泛适用于工业、环保、家居等场景，助力智能化气体安全管理。"
            ]
          }
        ],
        detail: [
          {
            name: "使用",
            table: {
              header: ["参数", "数值"],
              body: [
                {"参数": "操作系统", "数值":"Android，HarmonyOS 4.X及其旧版本和IOS"},
                {"参数": "微信版本", "数值":"8.0.55及以上"},
                {"参数": "蓝牙RSSI", "数值":"<90"},
                {"参数": "网络", "数值":"WIFI/4G，蓝牙"},
                {"参数": "客户权限", "数值":"蓝牙"},
              ]
            }
          }, {
            name: '小程序码',
            imgUrl: 'wx_inside.png'
          }
        ]
      },  {
        id: "033",
        name: "电子鼻小程序",
        dec: "电子鼻小程序",
        imgUrl: "wx-fourleaf.png",
        introduction: [
          {
            name: "介绍",
            text: [
              "该电子鼻小程序深度融合艾感科技仿生嗅觉芯片技术，实现对复杂气味与混合气体的智能识别及精准分析。是一款通过蓝牙连接四味獾模组(2×2阵列)进行算法训练、记录数据，就能识别气体功能的小程序。",
              "可广泛应用于环境监测、工业生产及智慧养老等多种场景，通过实时数据可视化、超标智能预警及历史记录追溯等核心功能，全面掌握空气质量动态。具有操作简单，蓝牙连接方便，适配用户多种不同场景和手机型号等特点。",
              "支持品牌界面、功能模块及数据看板的个性化定制，以灵活的服务模式满足不同行业需求，为气体监测提供高效、精准且智能化的解决方案。"
            ]
          }
        ],
        detail: [
          {
            name: "使用",
            table: {
              header: ["参数", "数值"],
              body: [
                {"参数": "操作系统", "数值":"Android，HarmonyOS 4.X及其旧版本和IOS"},
                {"参数": "微信版本", "数值":"8.0.51及以上"},
                {"参数": "RSSI", "数值":"<90"},
                {"参数": "网络", "数值":"WIFI/4G，蓝牙"},
                {"参数": "客户权限", "数值":"蓝牙"},
              ]
            }
          }, {
            name: '小程序码',
            imgUrl: 'wx_fourleaf.png'
          }
        ]
      },{
        id: "034",
        name: "恶臭监测小程序",
        dec: "恶臭监测小程序",
        imgUrl: "wx-hanlan.png",
        introduction: [
          {
            name: "介绍",
            text: [
              "恶臭在线智能监测小程序专为环境治理、工业监管及市政设施打造。系统实时对接电子鼻监测设备，精准量化臭气浓度（OU值）及硫化氢、氨气、VOCs等多种关键恶臭因子。数据实时上传、动态刷新。",
              "系统内置智能预警机制，一旦浓度超标，即时触发声光报警并推送通知、生成数据趋势分析可视化报表，为污染溯源与治理成效评估提供科学依据，助力快速响应与决策。",
              "我们提供全方位定制服务，可根据环保部门、企业或园区不同需求，个性化定制界面风格、功能模块与数据看板，并开放API接口，无缝对接各级监管平台，实现7×24小时精准化、智能化环境监管，为城市空气质量提升提供有力支撑。"
            ]
          }
        ],
        detail: [
          {
            name: '应用场景',
            imgUrl: 'cap_demo.png'
          }, {
            name: "使用",
            table: {
              header: ["参数", "数值"],
              body: [
                {"参数": "操作系统", "数值":"Android，HarmonyOS 4.X及其旧版本和IOS"},
                {"参数": "微信版本", "数值":"8.0.51及以上"},
                {"参数": "RSSI", "数值":"<90"},
                {"参数": "网络", "数值":"WIFI/4G，蓝牙"},
                {"参数": "客户权限", "数值":"蓝牙"},
              ]
            }

          // }, {
          //   name: '应用场景',
          //   imgUrl: 'wx_fourleaf.png'
          }
        ]
      },{
        id: "035",
        name: "猫砂盆除臭器小程序",
        dec: "猫砂盆除臭器小程序",
        imgUrl: "wx-catbox.png",
        introduction: [
          {
            name: "介绍",
            text: [
              "这款小程序，是猫砂盆智能除臭器的便捷交互入口。它深度集成艾感科技仿生电子鼻技术和智能AI算法技术，实现对猫砂盆氨气、硫化氢等异味分子的精准识别与量化监测。",
              "通过蓝牙或Wi-Fi实时连接智能除臭器，用户可远程查看空气质量动态、设备运行状态及耗材寿命，支持自动、手动、定时等多种除臭模式切换，让养宠环境持久清新。",
              "小程序内置猫咪如厕记录功能，智能统计如厕频率、时长等数据，异常情况及时预警，辅助主人关注宠物泌尿健康。支持多设备管理，适配不同品牌与型号的智能猫砂盆及除臭装置。同时，小程序的个人主页整合了清洁日历和好物商城，及时提醒你换猫砂和直购平价耗材，避免过度更换，持续降低长期使用成本。",
              "从实时监测到智能除臭，再到健康管理，全方位守护你与猫咪的呼吸健康，让养猫生活更清新省心。"
            ]
          }
        ],
        detail: [
          {
            name: '功能主导页',
            imgUrl: 'catbox-operator.png'
          }, {
            name: "产品参数",
            table: {
              header: ["参数", "数值"],
              body: [
                {"参数": "操作系统", "数值":"Android，HarmonyOS 4.X及其旧版本和IOS"},
                {"参数": "微信版本", "数值":"8.0.51及以上"},
                {"参数": "RSSI", "数值":"<90"},
                {"参数": "网络", "数值":"WIFI/4G，蓝牙"},
                {"参数": "客户权限", "数值":"蓝牙"},
              ]
            }
          // }, {
          //   name: '小程序码',
          //   imgUrl: 'wx_fourleaf.png'
          }
        ]
      },{
        id: "036",
        name: "智能纸尿裤小程序",
        dec: "智能纸尿裤小程序",
        imgUrl: "wx-diaper.png",
        introduction: [
          {
            name: "介绍",
            text: [
              "这款小程序可以收集智能纸尿裤上的传感器数据，并实时同步到云端服务器，是一款专为家庭、养老院及护理机构设计的系统设备。",
              "它能提供尿湿、排便及体温异常精准监测服务，手机就能动态化接收数据，及时干预护理提醒更换，避免皮肤溃烂与红臀问题。小程序支持多人共享监护，家人和护理员都能远程查看排泄记录、健康趋势与护理建议，减轻照护人员负担。",
              "可根据品牌商、养老机构或月子中心单位需求，深度个性化定制小程序界面、品牌标识、功能模块与数据看板，支持对接机构管理系统与物联网平台，助力构建智慧养老与母婴健康生态。"
            ]
          }
        ],
        detail: [
          {
            name: '功能主导页',
            imgUrl: 'darper-flow.png'
          }, {
            name: "产品参数",
            table: {
              header: ["参数", "数值"],
              body: [
                {"参数": "操作系统", "数值":"Android，HarmonyOS 4.X及其旧版本和IOS"},
                {"参数": "微信版本", "数值":"8.0.51及以上"},
                {"参数": "RSSI", "数值":"<90"},
                {"参数": "网络", "数值":"WIFI/4G，蓝牙"},
                {"参数": "客户权限", "数值":"蓝牙"},
              ]
            }
          // }, {
          //   name: '小程序码',
          //   imgUrl: 'darper-flow.png'
          }
        ]
      }
    ]
  }
]
const lastNews = [
  {
  //   date: '2026-05-11',
  //   title: '关于拟提名中国发明协会2026年度“发明创业奖”的公示',
  //   text: '根据《中国发明协会关于2026年度“发明创业奖”评选工作的通知》相关要求，现将我单位合作拟提名2026年度发明创业奖的项目予以公示。',
  //   url: 'https://www.aisensing.cn/#/newsDetail/01',
  //   imgUrl: 'news24.jpg',
  //   id: '01',
  //   detail: [
  //     "项目名称：复杂环境下高性能气体传感器的关键技术及应用",
  //     "完成人：颜佳、宋志龙、范智勇、许晖、李华明",
  //     "完成单位：江苏大学、艾感科技（广东）有限公司",
  //     "类型：成果奖",
  //     "公示时间为2026年5月12日至2026年5月18日（共7个自然日）。",
  //     "任何单位或个人若对项目公示信息有异议，应在公示期内以书面形式向我单位提出。书面异议材料应当签署真实姓名或加盖单位公章，并注明联系方式，否则不予受理。",
  //     "联系人：梁欢",
  //     "电 话：13288226337",
  //     "通讯地址：佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801"
  //   ]
  // }, {
      date: '2026-05-27',
    title: '艾感科技邀您共赴第八届MEMS智能传感器产业生态发展大会',
    text: '2026年5月30-31日，第八届MEMS智能传感器产业生态发展大会将在安徽蚌埠古民居博览园隆重启幕。这是行业内颇具影响力和引领力的产业盛会，本次大会以“芯聚江淮，智感世界”为主题搭建了一个传感器领域沟通平台，预计会有600多家产业链企业齐聚现场。仿生嗅觉芯片领域创新企业艾感科技，在低功耗、微型化、智能化方面取得了突破性进展，是全球率先实现片内超大规',
    url: 'https://mp.weixin.qq.com/s/0PJLxMoK3RtpgGS4w4K7Xg',
    imgUrl: 'news30.jpg'
  }, {
        date: '2026-05-20',
    title: '拿下国际金奖！这家嗅觉传感企业有多厉害？',
    text: '嗅觉是目前唯一尚未被机器全面替代的感官，艾感科技致力于推动嗅觉全面数字化、机器化，填补行业空白。2018年，艾感科技(广东)有限公司在佛山成立，累计融资3000万元人民币，提供仿生嗅觉芯片从研发到应用的全场景解决方案。截至目前，艾感科技手握130项自主知识产权，涵盖发明专利、实用新型专利、软件著作权等多类资质，具备强劲的研发实力和技术竞争力',
    url: 'https://mp.weixin.qq.com/s/SV3FEMaC11lw_RApEfXrcw',
    imgUrl: 'news29.jpg'
  }, {
        date: '2026-05-12',
    title: '佛山市人大常委副主任薛立伟一行赴艾感科技考察调研',
    text: '5月12日，佛山市人大常委会副主任、佛山市科学技术局局长薛立伟，佛山市科学技术局副局长李谦一行莅临艾感科技（广东）有限公司开展考察，艾感科技总经理薛峰博士热情接待并陪同调研。调研组实地参观了企业产品展示区与研发实验室，双方就企业核心技术、产业化落地情况进行交流。薛峰博士系统介绍了艾感科技在嗅觉传感器领域的技术突破。企业凭借自研的纳米蜂巢（NHC）核心',
    url: 'https://mp.weixin.qq.com/s/SV3FEMaC11lw_RApEfXrcw',
    imgUrl: 'news28.jpg'
  }, {
        date: '2026-05-01',
    title: '企业动态｜佛山市科学技术局领导莅临艾感科技考察指导',
    text: '2026年4月30日，佛山市科学技术局副局长李谦、人才科科长陈志敏一行莅临艾感科技（广东）有限公司开展工作调研，艾感科技总经理薛峰博士对考察组一行的到来表示热烈欢迎并全程陪同交流。艾感科技是国家高新技术、专精特新企业，专注仿生嗅觉芯片、气体传感器及其模组的研发、量产与应用，是全球率先提供商用大规模气体传感器阵列芯片厂商（单芯片可集成万个气敏传感单元）',
    url: 'https://mp.weixin.qq.com/s/jC35M02JM5GV_NttaVvzOQ',
    imgUrl: 'news27.jpg'
  }, {
        date: '2026-04-02',
    title: '突破！范智勇教授团队用一枚气味戒指改写智能穿戴新体验',
    text: '2026年3月27日，艾感科技（广东）有限公司董事长范智勇教授（显示与光电子全国重点实验室联合主任、全球前2%学者）带领学术研发团队在国际期刊《自然•通讯》（Nature Communications）上发表重磅成果：成功研制出全球首款集“微型化嗅觉芯片、AI算法、个性化健康代理、可穿戴戒指”于一体的人体代谢气味监测系统——AI可穿戴嗅觉生物识别戒指',
    url: 'https://mp.weixin.qq.com/s/MIhr8sH7E3ib_WHl-757Wg',
    imgUrl: 'news26.jpg'
  }, {
        date: '2026-03-30',
    title: '深圳传感器展必看！全球大规模阵列嗅觉芯片玩家即将亮相！',
    text: '2026年4月14-16日，Sensor Shenzhen 2026（第四届深圳国际传感器与应用技术展览会）将在深圳会展中心（福田）盛大举行。艾感科技（广东）有限公司将携纳米蜂巢（NHC）第三代半导体气体传感器技术与全场景解决方案亮相7号馆7B303展台，与行业伙伴共探嗅觉感知的无限可能！本届展会将汇聚600多家国内外传感器产业链企业，覆盖上下游资源板块',
    url: 'https://mp.weixin.qq.com/s/S8XNHOQtZOiNefto_vk21g',
    imgUrl: 'news25.jpg'
  }, {
        date: '2026-03-25',
    title: '企业动态｜禅城区政协携港澳企业家代表团莅临艾感科技视察',
    text: '3月25日上午，2026年佛山市禅城区两会启幕之际（3月25日至27日），禅城区政协、港澳委领导率队，携一众港澳企业负责人莅临艾感科技（广东）有限公司开展两会前实地视察与调研，了解辖区高新技术企业发展实情。视察伊始，艾感科技联合创始人周总（周清峰教授，广东省高层次人才，主持过多项国家级、省部级重点科研项目 ）向调研组重点介绍了企业核心荣誉与技术优势',
    url: 'https://mp.weixin.qq.com/s/sBbYStm-t6sHoLnaq0cwmw',
    imgUrl: 'news24.jpg'
  }, {
    date: '2026-02-26',
    title: '开工大吉│蓄势待发，共启新程',
    text: '金马踏福开财运，蓄势待发启新程。2026年２月２6日（正月初十），艾感科技（广东）有限公司开工仪式于上午９时整在佛山顺盈嘉智能科技园举行，总经理薛峰先生与公司全体同仁共祝开门红，开局皆兴旺。开工仪式上，薛总向全体员工致以新春祝福，并发表了热情洋溢的开工致辞。“征程万里风正劲，重任千钧再扬帆。”薛总强调，马年象征着奔腾与活力，代表着速度与效率。他号召全',
    url: 'https://mp.weixin.qq.com/s/ydphowGhJDY7_ondPOWdcQ',
    imgUrl: 'news01.jpg'
  }, {
    date: '2026-02-09',
    title: '喜报！艾感科技荣获“专精特新中小企业”称号',
    text: '近日，佛山市中小企业服务局公示了“佛山市2025年度专精特新中小企业近日，佛山市中小企业服务局公示了“佛山市2025年度专精特新中小企业”认定名单。艾感科技（广东）有限公司凭借先进的产品与技术，高质量的企业创新能力，继荣膺“国家高新技术企业”后，喜获“专精特新中小企业”荣誉称号。”认定名单。艾感科技（广东）有限公司凭借先进的产品与技术，高质量的企业创',
    url: 'https://mp.weixin.qq.com/s/cmfKDHs1dcG-Y7ZgS9TPtQ',
    imgUrl: 'news02.jpg'
  }, {
    date: '2026-02-06',
    title: '突破！艾感嗅觉芯片赋能冰箱，开启新鲜新时代',
    text: '冰箱在家庭电器中不可或缺，智能家电时代，消费者对冰箱的职责要求不断升级。以往我们判断食材是否变质，都是看标识的过期标签或凑近鼻子去闻。这种方法主观性强，常会因混合异味产生误判、浪费食物，有时还会带来健康隐患，造成经济损失。显然，只能精细控制温度，无法检测食物新鲜度的冰箱，已经满足不了消费者需求了。艾感科技董事长范智勇先生曾表示：“真正智能的冰箱，不仅',
    url: 'https://mp.weixin.qq.com/s/nlL7g4j15lzl5vlzKXerSA',
    imgUrl: 'news03.jpg'
  }, {
    date: '2026-02-05',
    title: '艾感科技2026年春节放假通知及备货提醒​',
    text: '艾感科技（广东）有限公司2026年春节放假通知及备货提醒，感谢各位客户过去一年里的支持与信任，值此2026年春节来临之际，艾感科技全体员工向您致以最诚挚的感谢与祝福！公司将于2月14日（腊月廿七）正式放假，假日期间线上订单正常接收，但暂停发货，复工后恢复物流。非紧急售后问题将在复工后处理，紧急业务可拨打值班电话。艾感提醒您及时备货确保节后业务顺利开展',
    url: 'https://mp.weixin.qq.com/s/qjnaTmlv_W0kdrAzJiNpMw',
    imgUrl: 'news04.jpg'
  }, {
    date: '2026-02-04',
    title: '艾感科技“仿生鼻”获中国科学技术馆致信褒奖',
    text: '近日，艾感科技（广东）有限公司收到了一封来自中国科学技术馆的感谢信，信中特别提到：“仿生嗅觉芯片”展品研发工作取得突出成效，赢得了社会各界的广泛赞誉。这封感谢信，不仅表达了对范智勇教授团队的科研实力认可，也彰显了艾感科技将“仿生嗅觉芯片”前沿成果推向公众视野，“让科技可感可触”，满足公众精神文化需求的社会价值。回望2025年北京首届“全国科普月”活动',
    url: 'https://mp.weixin.qq.com/s/zPcWh4HnEmLSmAqYkuEqcg',
    imgUrl: 'news05.jpg'
  }, {
    date: '2026-01-31',
    title: '艾赋新能│艾感科技2025年度答卷',
    text: '凯歌辞旧岁，壮志启新程。2026年1月30日晚，艾感科技（广东）有限公司在金腾阁酒店举行了“2025年度总结大会暨表彰大会”。艾感人齐聚一堂，复盘过往、共绘未来。2025年，艾感科技以技术为内核，以标准为基石，在资质建设、知识产权与产品创新实现了新突破。我们顺利通过ISO三体系认证（质量、环境、职业健康安全管理体系），标志着公司在项目管理、服务交付及',
    url: 'https://mp.weixin.qq.com/s/dDoNSjYLQm8nbSXn_GHe8A',
    imgUrl: 'news06.jpg'
  }, {
    date: '2025-09-17',
    title: '展览资讯│艾感前沿科技亮相首届“全国科普月”',
    text: '艾感前沿科技亮相首个“全国科普月”活动。2025年9月1日，以“科技改变生活，创新赢得未来”为主题的首届“全国科普月”活动在北京中国科学技术馆启幕。本届活动会集中展示30多个科研团队的前沿科学技术，通过成果展示、科普展演、互动体验等多元形式，全方位激发公众对科学的兴趣。此次在馆内南大厅展区首批亮相的仿生科技成果包括艾感科技团队全程自主研发的“仿生鼻”',
    url: 'https://mp.weixin.qq.com/s/QLCJU5hqGw9gXCbOaD_J7g',
    imgUrl: 'news07.jpg'
  }, {
    date: '2025-08-29',
    title: '企业资讯│艾感科技董事长向国家科技部部长展示创新科技​',
    text: '全国重点实验室授牌，打造科创新高地。近日，国家科学技术部（科技部）部长阴和俊率代表团访问香港科技大学，考察前沿科研领域的最新突破与人才培养成果，并为包括“显示与光电子全国重点实验室”在内的三个在港全国重点实验室授牌。范智勇先生不仅是香港科技大学电子与计算机工程系讲席教授、显示与光电子全国重点实验室联合主任，也是艾感科技的董事长。此次，他向阴和俊部长一',
    url: 'https://mp.weixin.qq.com/s/uw5uwl_o3NCUFCLW6XqhiA',
    imgUrl: 'news08.jpg'
  }, {
    date: '2025-07-01',
    title: '年中盘点│艾感科技2025年上半年大事记',
    text: '以科技之火，燃品质之光',
    url: '2025年上半年，艾感科技在技术、资本及市场端均取得突破性进展。公司入选佛山“聚光灯计划”企业，并凭借“生物仿生芯片-电子鼻”斩获日内瓦国际发明展金奖；获瀚蓝环境投资，估值达2.5亿元。商务方面，与中车数智、均普智能、作为科技及青鸟消防达成战略合作，拓展工业、养老及消防领域应用。产品上，“四叶草”模组实现量产，“九宫格”完成小批打样，智能纸尿裤项目启动',
    imgUrl: 'news09.jpg'
  }, {
    date: '2025-05-14',
    title: '艾感「黑科技」曝光！获国家部委点赞',
    text: '近日，全国政协常委、教科卫体委员会副主任王志刚先生率代表团访问香港科技大学，与该校科研主任范智勇教授（任艾感科技董事长、港科大先进显示与光电子技术国家重点实验室主任）展开深度对话。范智勇教授揭秘艾感科技与港科大的深度绑定模式，代表团成员中科院院士武向平、全国政协委员徐星、蔡荣根等十余位国家部委负责人，重点考察了港科大的科研转化成果及艾感科技的技术应用',
    url: 'https://mp.weixin.qq.com/s/yPOdsmjcZzVCHWGjvqZA_g',
    imgUrl: 'news10.jpg'
  }, {
    date: '2025-05-13',
    title: '艾感快讯│重磅！艾感科技获国际发明双奖',
    text: '近日，第50届日内瓦国际发明展落幕。艾感科技（广东）有限公司（下称：艾感科技）凭借"纳米蜂巢（NHC）第三代半导体气体传感器技术"项目，从全球40多国1000余项创新成果中突围，包揽“日内瓦国际发明金奖及特别贡献奖”双项大奖。日内瓦国际发明展始创于1973年，由瑞士联邦政府、世界知识产权组织等权威机构主办，评审标准严苛程度连续五年位列全球发明展榜首',
    url: 'https://mp.weixin.qq.com/s/zswZGI-xD_Q0-hENjYVRSA',
    imgUrl: 'news11.jpg'
  }, {
    date: '2025-03-05',
    title: '携手瀚蓝，共创未来│全球首创嗅觉芯片技术赋能环保新篇章',
    text: '在环保科技蓬勃发展的今天，艾感科技有幸与环保行业领军企业瀚蓝达成深度合作。通过瀚蓝的战略投资与资源赋能，我们的全球唯一嗅觉芯片技术正加速落地环保治理场景，共同书写智慧环保的新篇章。瀚蓝环境股份有限公司（以下简称“瀚蓝”）是一家专注于环境服务产业的上市公司。业务领域涵盖固废处理、能源、供水、排水等，是中国环境企业十强、连续十一年被评为全国固废处理十大影',
    url: 'https://mp.weixin.qq.com/s/TJ619EoacXsvq2qs_vJn7g',
    imgUrl: 'news12.jpg'
  }, {
    date: '2025-02-28',
    title: '艾感科技与均普研究院达成战略合作，共启智能机器人新篇章',
    text: '2025年1月，艾感科技与宁波均普人工智能与人形机器人研究院正式签署战略合作协议，开启双方在人工智能与智能机器人领域的深度协同，为智能制造领域注入新动能！艾感科技将凭借其独创的纳米蜂巢（NHC）第三代半导体气体传感器技术，为均普研究院的人形机器人提供高精度的仿生嗅觉感知能力，共同攻克机器人在复杂环境中的感知技术难题。双方将通过联合研发、供应链协同与市',
    url: 'https://mp.weixin.qq.com/s/dKigJu3PUyTzVN_FljEyzw',
    imgUrl: 'news13.jpg'
  }, {
    date: '2025-01-20',
    title: '艾感科技2024辞旧迎新年会活动：嗅探未来，智启新篇',
    text: '2025年1月17日，艾感科技在佛山市尖沙咀酒店举办了主题为“嗅探未来，智启新篇”的2024辞旧迎新年度晚会。活动汇聚了公司全体员工及特邀嘉宾，共同回顾过去一年的奋斗历程，展望未来发展蓝图。年会伊始，董事长范智勇与总经理分别发表致辞，总结年度成就并规划新一年的战略方向，极大地鼓舞了团队士气。随后的年度颁奖典礼隆重表彰了“年度最佳团队”、“优秀管理者”',
    url: 'https://mp.weixin.qq.com/s/X3mztgVSEpVKanvyOH51tQ',
    imgUrl: 'news14.jpg'
  }, {
    date: '2025-01-16',
    title: '艾感科技│2025年春节放假通知',
    text: '在这辞旧迎新的美好时刻，艾感科技全体员工向您致以最诚挚的感谢与新春祝福。根据国家法定节假日规定，我司2025年春节放假时间为2025年1月26日至2月9日，2月10日正式开工。放假期间业务将暂停处理，为确保双方合作项目正常推进，建议您提前做好工作安排。新的一年，我们将继续秉持专业、诚信、共赢的理念，为您提供更优质的产品和服务，期待与您携手共创新辉煌',
    url: 'https://mp.weixin.qq.com/s/idDO_q-fb2AoTP-0TPu-mA',
    imgUrl: 'news15.jpg'
  }, {
    date: '2025-01-07',
    title: '艾感团建：足球赛场燃热血，轰趴烧烤嗨翻天',
    text: '艾感科技举办了一场以“足球赛场燃热血，轰趴烧烤嗨翻天”为主题的企业团建活动，旨在增强团队凝聚力与协作精神。活动分为两部分：首先是一场公司领导与员工们共同参与的足球友谊赛，诠释拼搏与团队合作精神；随后在天台轰趴馆举行烧烤派对。现场不仅有美食、KTV和游戏机，还特别举办了温馨的集体生日会。整个活动氛围轻松愉快，缓解了工作压力，为后续团队协作奠定了坚实基础',
    url: 'https://mp.weixin.qq.com/s/oGhpIexVG8Z8-hK2HC2yiQ',
    imgUrl: 'news16.jpg'
  }, {
    date: '2025-01-01',
    title: '聚光耀企，共赢未来！艾感科技入选首批“聚光灯计划”',
    text: '2024年12月30日，佛山市禅城区“聚光灯计划”首批企业发布暨聚光赋能交流会隆重召开。艾感科技（广东）有限公司凭借其在仿生嗅觉芯片及气体传感器领域的卓越创新力与高成长性，从众多参评企业中脱颖而出，成功入选禅城区2024年度“聚光灯计划”新锐企业名单。禅城区“聚光灯计划”是区委、区政府为响应新时代高质量发展要求而重点打造的优质企业选树培育工程。该计划',
    url: 'https://mp.weixin.qq.com/s/3ywx9tHeWEjPlgPPp-3Urg',
    imgUrl: 'news17.jpg'
  }, {
    date: '2024-12-21',
    title: '喜讯│艾感科技荣获第二届佛山高价值专利成果转移转化大赛铜奖',
    text: '2024年12月12日至13日，第二届佛山高价值专利成果转移转化大赛（以下简称“高转赛”）决赛将在佛山举行。50个从初赛、复赛层层选拔中脱颖而出的高水平、高质量专利成果转移转化项目，将在决赛舞台展开对决，共同竞逐大赛金、银、铜等奖项。第二届高转赛由佛山市人民政府、国家知识产权局知识产权发展研究中心主办。赛事于今年9月5日正式启动，吸引了来自全国各地的',
    url: 'https://mp.weixin.qq.com/s/jZ4hdNgDdLAuiwqEcRDeZw',
    imgUrl: 'news18.jpg'
  }, {
    date: '2024-11-07',
    title: '艾感茶话会及生日会：相伴相聚 一路同行',
    text: '金秋送爽，情暖艾感。近日，艾感科技精心举办了一场主题为“相伴相聚，一路同行”的员工茶话会暨十月员工生日会。活动旨在为在金秋十月迎来生日的员工们（以下简称“寿星”）打造一个温馨、难忘的专属时刻，让大家在繁忙的研发与工作之余，感受到公司大家庭的关怀与温暖。活动当天，行政部的同事们早早地便将会场布置一新。气球、彩带与温馨的灯光交相辉映，营造出浓厚的节日氛围',
    url: 'https://mp.weixin.qq.com/s/ksQ1c8YCIs5vr-7P9xs9ew',
    imgUrl: 'news19.jpg'
  }, {
    date: '2024-10-14',
    title: '艾感团建：阳光运动，释放自我',
    text: '在现代快节奏的工作生活中，团队建设和员工健康已成为企业管理的两大核心要素。为了增进同事间的了解与合作，提升团队凝聚力和员工身体素质，我公司近期组织了一次别开生面的团建运动活动。本次活动以篮球、乒乓球和羽毛球三项体育运动为载体，旨在让员工在激烈的竞技中感受运动的乐趣，共同迎接挑战，收获成长与快乐。篮球作为团队运动的佼佼者，不仅考验队员们的身体素质，更是',
    url: 'https://mp.weixin.qq.com/s/KNwf6LO7lLYBBIg55QcHaw',
    imgUrl: 'news20.jpg'
  }, {
    date: '2022-12-30',
    title: '祝贺│艾感董事长范智勇教授摘获首届“中银香港科技创新奖”',
    text: '热 烈 祝 贺艾感科技董事长—范智勇教授荣获首届「中银香港科技创新奖」新材料新能源奖项。「中银香港科技创新奖」（科创奖）是由香港科技创新联盟主办、中国银行（香港）冠名赞助的公益性奖项，为鼓励在香港进行科学技术创新和科技成果转化而设，今年首届举行。科创奖致力于推动香港的科学技术创新发展，奖励主要在香港进行科学技术创新和科技成果转化，并取得杰出成就的个人',
    url: 'https://mp.weixin.qq.com/s/P1byythew5dv1WjC-BJ-NA',
    imgUrl: 'news21.jpg'
  }, {
    date: '2022-09-24',
    title: '恭喜艾感科技董事长范智勇教授荣获“科学探索奖”',
    text: '第四届“科学探索奖”获奖名单正式揭晓，50名青年科学家榜上有名。恭喜艾感科技董事长范智勇教授荣登榜单。“科学探索奖”是目前国内金额最高的青年科技人才资助计划之一。奖项面向基础科学和前沿技术领域，奖项秉持「面向未来、奖励潜力、鼓励探索」的宗旨，每年遴选不超过50名获奖人，每位获奖人将在5年内获得总计300万元人民币的奖金，且可自由支配。“科学探索奖”于',
    url: 'https://mp.weixin.qq.com/s/SdUQp-bEfNNIr8VVGcAacg',
    imgUrl: 'news22.jpg'
  }
]
const oldNews = [
  {
    id: "48",
    date: '',
    title: '90%铲屎官都忽略了：科学养宠从嗅出异味开始！',
    text: '实时感知空气异常',
    url: 'https://mp.weixin.qq.com/s/W-54bxCUKPt5Un-a65cUtw',
    imgUrl: 'plan(48).jpg'
  }, {
    id: "49",
    date: '',
    title: '升级！艾感科技推出320通道并行测试系统',
    text: '气敏元件测试系统',
    url: 'https://mp.weixin.qq.com/s/VwJzrXDgHAuokPhlhx7m3A',
    imgUrl: 'plan(49).jpg'
  }, {
    id: "50",
    date: '',
    title: '扫地机行业卷了这么多年，终于有人想到这个！',
    text: '闻味识污 因污施策',
    url: 'https://mp.weixin.qq.com/s/oOcpIrshLM0sBQcPhOUM5g',
    imgUrl: 'plan(50).jpg'
  }, {
    id: "51",
    date: '',
    title: '卷完智驾卷空气，车主、车企双双盯上空气质量',
    text: '车内空气异味监测方案',
    url: 'https://mp.weixin.qq.com/s/T8iAcKjJJCouKSzgqZTAtg',
    imgUrl: 'plan(51).jpg'
  }, {
    id: "43",
    date: '',
    title: '电子鼻：探索气味世界的神奇工具',
    text: '赋能千行百业',
    url: 'https://mp.weixin.qq.com/s/T2GhqW8qJFxu3WXJ6dKs_w',
    imgUrl: 'plan(43).jpg'
  }, {
        id: "44",
    date: '',
    title: '中毒窒息，4死3伤！别让“小侥幸”酿成“大悲剧”',
    text: '测得准、抗糙耐用、稳定可靠',
    url: 'https://mp.weixin.qq.com/s/yI3GUbZuuP3Sdq5egzhwHw',
    imgUrl: 'plan(44).jpg'
  }, {
        id: "45",
    date: '',
    title: '16人睡梦中遇难：燃气泄漏时，你的鼻子根本靠不住',
    text: '够快、够稳、够准',
    url: 'https://mp.weixin.qq.com/s/hYz068xQ7OoCSslJ5OYyig',
    imgUrl: 'plan(45).jpg'
  }, {
        id: "46",
    date: '',
    title: '顺利交付！艾感科技携手中国电信，共启安防“嗅觉”时代',
    text: '多模态摄像头：能看更能闻，守护再升级',
    url: 'https://mp.weixin.qq.com/s/2PYnIpSW2mutSTvqzOmnwA?token=749968275&lang=zh_CN',
    imgUrl: 'plan(46).jpg'
  }, {
        id: "47",
    date: '',
    title: '艾感科技携手吉利汽车研究院，深化智能汽车座舱方案',
    text: '嗅见智能出行新未来！',
    url: 'https://mp.weixin.qq.com/s/ic8KB5oAf3nD7MyWrEA0sg',
    imgUrl: 'plan(47).jpg'
  }, {
    id: "01",
    date: '',
    title: '“8•18”窒息事故警示！电子鼻如何守护有限空间？',
    text: '血色警示，别让悲剧重演！',
    url: 'https://mp.weixin.qq.com/s/sBj86Ig9jHSadlQNO8xoCg',
    imgUrl: 'plan(1).jpg'
  }, {
    id: "02",
    date: '',
    title: '宝妈吐槽公公“熏醉”孩子上热搜！',
    text: '看不见的酒气，更需防护！',
    url: 'https://mp.weixin.qq.com/s/UO_Cw8B7XJMGBA04_cmeog',
    imgUrl: 'plan(2).jpg'
  }, {
    id: "03",
    date: '',
    title: '热搜！建议拆完快递的纸箱立即扔掉',
    text: '看似节俭，实则筑起“隐患”的围城',
    url: 'https://mp.weixin.qq.com/s/Klg6K9bEgrhdzcTTXMh5-Q',
    imgUrl: 'plan(3).jpg'
  }, {
    id: "04",
    date: '',
    title: '异味毁尽养宠快乐？艾感智能猫砂盆除臭器，还你一个清新家！',
    text: '“精准、智能、安全、省钱”清除养宠异味',
    url: 'https://mp.weixin.qq.com/s/hIpmt649Ux2-0eglA8zLlw',
    imgUrl: 'plan(4).jpg'
  }, {
    id: "05",
    date: '',
    title: '照护革新：艾感科技“智慧养老”，让纸尿裤智能化！为尊严加分，为爱减负！',
    text: '告别眼观手测，艾感科技重新定义老龄健康护理的未来',
    url: 'https://mp.weixin.qq.com/s/pCdVpK7j_M43CdNM-otFkQ',
    imgUrl: 'plan(5).jpg'
  }, {
    id: "06",
    date: '',
    title: '央视曝光毒玩具，艾感科技“电子鼻”把关安全！',
    text: '艾感电子鼻24小时守在生产线，从源头消除气味安全隐患',
    url: 'https://mp.weixin.qq.com/s/y0aYaZzKjEP_LVwAyInISA',
    imgUrl: 'plan(6).jpg'
  }, {
    id: "07",
    date: '',
    title: '突发闪爆！南京燃气闪爆事故1死2伤，你家燃气安全吗？',
    text: '别让疏忽酿成无法挽回的悲剧',
    url: 'https://mp.weixin.qq.com/s/VOGrM3QL5mRISeqHwRfMRQ',
    imgUrl: 'plan(7).jpg'
  }, {
    id: "08",
    date: '',
    title: '嗅觉数字革命：我们如何用“气味魔盒”封存一生的美好瞬间？',
    text: '气味，是通往过去的时光机',
    url: 'https://mp.weixin.qq.com/s/kDSiOr9RQYxDncPKSkFQxw',
    imgUrl: 'plan(8).jpg'
  }, {
    id: "09",
    date: '',
    title: '科普｜仿生电子鼻如何嗅出十亿分之一的气体浓度？',
    text: '电子鼻技术为气体监测提供全新解决方案',
    url: 'https://mp.weixin.qq.com/s/NRbVLRTkl8Hkdvr7uvElgg',
    imgUrl: 'plan(9).jpg'
  }, {
    id: "10",
    date: '',
    title: '艾感科技电子鼻驱动嗅觉，具身智能机器人迎大利好！',
    text: '开启机器嗅觉新感知',
    url: 'https://mp.weixin.qq.com/s/FSTCVxJNZA-zRIxDZdpxfw',
    imgUrl: 'plan(10).jpg'
  }, {
    id: "11",
    date: '',
    title: '健康指南｜月圆人团圆，特殊人群如何健康吃月饼？',
    text: '月饼与健康如何兼得？',
    url: 'https://mp.weixin.qq.com/s/evDM7ntGNvb0ZzIT4tfggw',
    imgUrl: 'plan(11).jpg'
  }, {
    id: "12",
    date: '',
    title: '装修房=毒气室？TVOC传感器为家人健康呼吸护航',
    text: '新房变毒房！乔迁喜悦后的健康惊魂～',
    url: 'https://mp.weixin.qq.com/s/et3dcC4ufXwMZj3xQXczEw',
    imgUrl: 'plan(12).jpg'
  }, {
    id: "13",
    date: '',
    title: '艾感科普｜剧毒、自燃、爆炸！半导体制程特殊气体小知识',
    text: '特气的分类与应用',
    url: 'https://mp.weixin.qq.com/s/fWFWspH7DKruJ8HCOu4fHg',
    imgUrl: 'plan(13).jpg'
  }, {
    id: "14",
    date: '',
    title: '安全用气系万家，规范操作，防患未“燃”保平安！',
    text: '拧紧安全阀，防患于未燃',
    url: 'https://mp.weixin.qq.com/s/sunJUzhL-gwWFWdf8L5vbA',
    imgUrl: 'plan(14).jpg'
  }, {
    id: "15",
    date: '',
    title: '半导体入门必读：看懂这3种模式，才算入门半导体！',
    text: '芯片产业经营模式',
    url: 'https://mp.weixin.qq.com/s/uZh5YIy-oyZq04wxvbQ-ZA',
    imgUrl: 'plan(15).jpg'
  }, {
    id: "16",
    date: '',
    title: '一文看懂2025世界机器人大会：智慧升级，具身智能成主角',
    text: '闻香识物，智造科技生活',
    url: 'https://mp.weixin.qq.com/s/A2-Zg9LKeCeciA4O0Tj1lg',
    imgUrl: 'plan(16).jpg'
  }, {
    id: "17",
    date: '',
    title: '芯片入门必看！2分钟彻底拆解芯片，科技小白秒懂！',
    text: '芯片入门科普',
    url: 'https://mp.weixin.qq.com/s/cLHAT1Z7CJyxDhDsPWKFPQ',
    imgUrl: 'plan(17).jpg'
  }, {
    id: "18",
    date: '',
    title: '嗅觉真相：杭州自来水异味事件，比“粪水”谣言更残酷',
    text: '技术破局：电子鼻系统如何监测与预警硫醚类物质',
    url: 'https://mp.weixin.qq.com/s/AGt_-YKzv42olz90LRos1Q',
    imgUrl: 'plan(18).jpg'
  }, {
    id: "19",
    date: '',
    title: '解决方案︱当智能遇上纸尿裤会是怎样？养老院、月子中心力荐',
    text: '专为婴幼儿、失智、失能群体设计',
    url: 'https://mp.weixin.qq.com/s/6PYcgPIU1NlN_pmXF4H-yA',
    imgUrl: 'plan(19).jpg'
  }, {
    id: "20",
    date: '',
    title: '小米YU7引爆市场，艾感车载电子鼻让车内空气“活”起来！',
    text: '告别傻净化，专治车内“臭”毛病',
    url: 'https://mp.weixin.qq.com/s/K_NxG1zALHPpr1w1T_mo_g',
    imgUrl: 'plan(20).jpg'
  }, {
    id: "21",
    date: '',
    title: '警惕！别让冰箱成健康刺客，AI电子鼻「嗅」出健康隐患',
    text: '食材变质早知道，腐坏无处藏',
    url: 'https://mp.weixin.qq.com/s/omJy1MaqRozRx94ktlDS5Q',
    imgUrl: 'plan(21).jpg'
  }, {
    id: "22",
    date: '',
    title: '居民投诉暴涨？看艾感科技如何搞定恶臭监测难题',
    text: '恶臭污染被列为世界七大环境公害之一',
    url: 'https://mp.weixin.qq.com/s/wTNhXBTnIXAj6n2zHJ0z9g',
    imgUrl: 'plan(22).jpg'
  }, {
    id: "23",
    date: '',
    title: '探秘｜艾感科技电子鼻，科技如何赋予机器「嗅觉」？',
    text: '电子鼻7×24小时工作捕捉空气中的气味分子',
    url: 'https://mp.weixin.qq.com/s/4egbSX1YwznSYWQBYo8dIg',
    imgUrl: 'plan(23).jpg'
  }, {
    id: "24",
    date: '',
    title: '养宠家庭福音，艾感科技破解扫地机器人世纪难题！',
    text: '嗅觉避障革命',
    url: 'https://mp.weixin.qq.com/s/e5De3ghHVO3dRU8SuFHcsw',
    imgUrl: 'plan(24).jpg'
  }, {
    id: "25",
    date: '',
    title: '祝贺｜单芯片解析千种气体？艾感NHC技术重塑嗅觉芯片性能',
    text: 'NHC嗅觉芯片技术引爆新场景',
    url: 'https://mp.weixin.qq.com/s/eSnQi3gTMxEXgOUMuYSbaw',
    imgUrl: 'plan(25).jpg'
  }, {
    id: "26",
    date: '',
    title: '养老院护理员「私藏好物」曝光，解决99%人的养老难题！',
    text: '90％护理员不知道的黑科技',
    url: 'https://mp.weixin.qq.com/s/IstDaTGKzl6Erm--NvAPLw',
    imgUrl: 'plan(26).jpg'
  }, {
    id: "27",
    date: '',
    title: '嗅觉黑科技出圈，艾感科技助力机器人 “闻香识物”',
    text: '机器人的鼻子，比狗鼻子还灵',
    url: 'https://mp.weixin.qq.com/s/n4Cyal5z6cNWnaxF10zkMg',
    imgUrl: 'plan(27).jpg'
  }, {
    id: "28",
    date: '',
    title: '智慧工业｜从被动到预见，智能头盔怎样嗅出隐形威胁？',
    text: '当前，大多工业防护体系存在致命盲区',
    url: 'https://mp.weixin.qq.com/s/3ojRsG0slMg-uAE1S4rV4A',
    imgUrl: 'plan(28).jpg'
  }, {
    id: "29",
    date: '',
    title: '撒贝宁魔性COS机器人，揭秘春晚机器天团背后黑科技',
    text: '机器人一次次成为全民热议的焦点！',
    url: 'https://mp.weixin.qq.com/s/uSNFmvuT_oo4hiXcW4HqBA',
    imgUrl: 'plan(29).jpg'
  }, {
    id: "30",
    date: '',
    title: '防火指南｜冬季火灾频发，居民住宅如何有效预防？',
    text: '提高防火意识、做好防范措施',
    url: 'https://mp.weixin.qq.com/s/_amz6iull3I_nVR5om7ybw',
    imgUrl: 'plan(30).jpg'
  }, {
    id: "31",
    date: '',
    title: '机械狗嗅探未来：机器狗装上艾感“电子鼻”，展示惊人潜能！',
    text: '赋予机器嗅觉感知世界',
    url: 'https://mp.weixin.qq.com/s/11iRwkAbu3oaj0SlEShf_w',
    imgUrl: 'plan(31).jpg'
  }, {
    id: "32",
    date: '',
    title: '酒驾检测新神器！酒精传感器赋能酒驾检测，打造行车安全防线！',
    text: '酒驾检测新方式',
    url: 'https://mp.weixin.qq.com/s/2eqv6GtnaP5olwC1aHLzjw',
    imgUrl: 'plan(32).jpg'
  }, {
    id: "33",
    date: '',
    title: '深圳住宅突发爆炸！燃气爆炸事故中气体传感器的作用是什么？',
    text: '早发现、早预警、早处置',
    url: 'https://mp.weixin.qq.com/s/s35_GrXjFXOjZ49A8aEr0g?poc_token=HMMFoWmjLznwqLWy5NLZXHFCSPVLKMybq6LmvcLG',
    imgUrl: 'plan(33).jpg'
  }, {
    id: "34",
    date: '',
    title: '气体传感器在储能中的应用',
    text: '提高储能安全性能',
    url: 'https://mp.weixin.qq.com/s/oX5fQZNnSFGXWJE7pqeKpw',
    imgUrl: 'plan(34).jpg'
  }, {
    id: "35",
    date: '',
    title: '六合一气体监测，安全守护你的每一口呼吸',
    text: '化工安全防线',
    url: 'https://mp.weixin.qq.com/s/rq5zpH_orF-9FC88Kouu2A',
    imgUrl: 'plan(35).jpg'
  }, {
    id: "36",
    date: '',
    title: '化工企业必备传感器：危险气体检测与预警',
    text: '化工安全防线',
    url: 'https://mp.weixin.qq.com/s/zheuFCS1l6n9D2d4Hu_SRQ',
    imgUrl: 'plan(36).jpg'
  }, {
    id: "37",
    date: '',
    title: '气体传感器在汽车领域的应用',
    text: '守护能源安全',
    url: 'https://mp.weixin.qq.com/s/_Q-IkCZM_wBYi4D_ekYMkg',
    imgUrl: 'plan(37).jpg'
  }, {
    id: "38",
    date: '',
    title: '气体传感器故障全解，轻松维护你的安全！',
    text: '检测特定气体浓度',
    url: 'https://mp.weixin.qq.com/s/2YhOGvqljKY6_DAYEzukqw',
    imgUrl: 'plan(38).jpg'
  }, {
    id: "39",
    date: '',
    title: '恶臭在线监测系统：守护清新空气的科技力量',
    text: '实时监测空气中恶臭物质的浓度',
    url: 'https://mp.weixin.qq.com/s/uK7o1fN1dPM8cfGSLfOA8g',
    imgUrl: 'plan(39).jpg'
  }, {
    id: "40",
    date: '',
    title: '大气环境在线监测，守护城市空气健康',
    text: '提供科学空气质量数据',
    url: 'https://mp.weixin.qq.com/s/DQgdQGsZ84ZtaQK8bwVSZg',
    imgUrl: 'plan(40).jpg'
  }, {
    id: "41",
    date: '',
    title: '燃气隐患猛如虎，气体传感器来守护！',
    text: '家庭燃气的“智能哨兵”',
    url: 'https://mp.weixin.qq.com/s/bOcA0AHzCWmCJmaE_Lsg-w',
    imgUrl: 'plan(41).jpg'
  }, {
    id: "42",
    date: '',
    title: '气体传感器在环保行业的应用',
    text: '为政府决策和公众健康提供科学依据',
    url: 'https://mp.weixin.qq.com/s/9-P7qhBXoVPP1oGGuj7WzA',
    imgUrl: 'plan(42).jpg'
  }, {
    id: "43",
    date: '',
    title: '电子鼻：探索气味世界的神奇工具',
    text: '赋能千行百业',
    url: 'https://mp.weixin.qq.com/s/T2GhqW8qJFxu3WXJ6dKs_w',
    imgUrl: 'plan(43).jpg'
  }
]
const jobList = [
  {
    name: '生产总监',
    subName: '佛山 硕士',
    contentList: [
      {
        title: "岗位职责",
        con: [
          "1、目标制定：负责与技术团队、销售团队和财务团队对接，参与制定事业部年度经营计划、预算方案，参与事业部重大财务、人事、业务问题的决策，并提出建议；",
          "2、计划执行：指导PMC制定生产计划工作，根据生产进度，统筹协调各车间的生产，组织分配人力，平衡设备、材料调度工作；",
          "3、物料管控：根据物料计划，监督采购供应计划落实，控制材料库存、来料质量、到货及时率情况，及时协调解决生产瓶颈物资；",
          "4、品控与优化：负责协助技术部的技术创新和质量保证工作，发现问题及时组织解决和处理，重大问题报总经理协商处理，保证产品的良品率，并持续优化提高，负责产品的品质检测，及不良品的处理；",
          "5、外发协调：指导外发厂家质量效率管理工作，确保外发工厂价格合理、质量合格，高效生产工作；",
          "6、进度管理：组织和完善生产指挥系统，检查生产工作，确保生产任务的达成。每周一次定期召开生产例会，分析生产形势，提出解决问题的办法和措施，保证各项生产技术指标的全面完成；",
          "7、安全管理：负责EHS工作，发现问题，立即督促整改；",
          "8、成本管理：全面负责精益生产推进，降低生产成本工作；",
          "9、设备管理：负责设备管理，提高设备完好率和利用率；",
          "10、绩效管理：评判生产人员的工作绩效；",
          "11、库存管理：组织产品的包装和物流，负责库存管理；",
          "12、工艺管理：改进生产工艺，提高生产效率；",
          "13、扩产管理：根据需要，规划新产线的购置与建设；",
          "14、协调管理：按照总经理的安排，协调技术团队、生产团队、和公司日常管理。"
        ]
      }, {
        title: "任职要求",
        con: [
          "1、211以上本科，电子、材料、化学等理工科相关专业，有管理类专业经历者优先；",
          "2、5年以上相关行业生产管理协调经验，至少3年生产管理工作经验，熟悉生产过程，有一定原材料的供应渠道；",
          "3、熟悉生产规程以及质量标准，具备良好的生产经营管理理念，有一定财务与法务知识；",
          "4、熟悉团队建设，熟悉工厂规划、场地布局、生产计划制定；",
          "5、具备战略管理能力、沟通协调的能力以及资源整合的能力，有全局观，能换位思考，抗压能力强；",
          "6、有4级以上英文水平；",
          "7、有硕士或博士学位者优先；",
          "8、有管理类证书者优先；"
        ]
      }, {
        title: "福利待遇",
        con: [
          "1、工作地点 佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801",
          "2、五险一金",
          "3、年薪 30w~60w，根据经验浮动",
          "4、有月绩效工资和年终奖，具体金额以任务完成情况进行衡量",
          "5、配期权"
        ]
      }
    ]
  }, {
    name: '硬件工程师',
    contentList: [
      {
        title: "岗位职责",
        con: [
          "1、负责空气监测站产品单板的硬件设计、调试等工作；",
          "2、维护现有产品，解决遗留问题；",
          "3、协助传感器、数据库等部门完成产品测试等工作。"
        ]
      }, {
        title: "任职要求",
        con: [
          "1、电子、电气、机电等相关专业，1-2年相关工作经验；",
          "2、能够独立完成硬件方案定型、器件选型、原理图与PCB设计、调试、测试维护工作，有单片机固件编写经验；",
          "3、至少熟悉一种电路设计软件；",
          "4、熟练使用常用的仪器，熟练使用电烙铁等工具；",
          "5、积极主动，勤奋好学，注重团队协作。"
        ]
      }, {
        title: "福利待遇",
        con: [
          "1、 根据工作经验，10K/月 – 20K/月",
          "2、 买社保",
          "3、 每年一次培训机会",
          "4、 年底双薪"
        ]
      }
    ]
  }, {
    name: '软件工程师',
    contentList: [
      {
        title: "岗位职责",
        con: [
          "1、负责微信小程序及手机APP开发(Android和iOS)、上线发布；",
          "2、负责PC应用平台实时数据采集软件开发；",
          "3、负责软件的维护与升级；",
          "4、参与公司产品讨论，编写设计、开发及实现文档。"
        ]
      }, {
        title: "任职要求",
        con: [
          "1、有丰富的PC软件和移动端开发经验；",
          "2、熟悉C++或Java语言， Qt、Android studio等软件开发环境；",
          "3、熟悉物联网应用协议，低功耗蓝牙、NB-IOT等设备调试；",
          "4、逻辑思维能力强，了解JS，熟练配合后台开发的程序整合；",
          "5、适应灵活的工作时间，随时对软件进行维护；",
          "6、熟悉vue，阿里G2，百度echart，JS,JQ微信小程序开发模式；",
          "7、熟悉springboot,Mybtais,javase,MQtt,AndroidUI,Framework,开发串口开发协议；",
          "8、熟悉mysql/mongodb等sql非sql数据库；",
          "9、熟悉ObjectiveC语言特性，了解HTTP/TCP协议。"
        ]
      }, {
        title: "福利待遇",
        con: [
          "1、 根据工作经验，10K/月 – 20K/月",
          "2、 买社保",
          "3、 每年一次培训机会",
          "4、 年底双薪"
        ]
      }
    ]
  }
]
const footLinkList = [{
        url: "http://gd.aisensing.cn/",
        name: "国家级网格化空气质量监测系统"
      }, {
        url: "http://nzair.aisensing.cn/",
        name: "禅城区南庄镇空气质量监测平台"
      }, {
        url: "http://nzaqi.aisensing.cn/",
        name: "老版南庄监控平台"
      }, {
        url: "http://nzdata.aisensing.cn/",
        name: "南庄大气微型站管理系统"
      }, {
        url: "http://nzserve.aisensing.cn/",
        name: "中山大学监控平台"
      }, {
        url: "http://nz.aisensing.cn/",
        name: "南庄镇大气质量智能化监控平台"
      }, {
        url: "http://hk.aisensing.cn/",
        name: "香港科大数据后台"
      }, {
        url: "http://web.aisensing.cn/",
        name: "艾感新版大气监测后台"
      }, {
        url: "http://admin.feelt-sport.com/",
        name: "智能鞋垫后台管理系统"
      }, {
        url: "http://tpapi.aisensing.cn/",
        name: "瀚蓝恶臭管理后台"
      }, {
        url: "http://nai.aisensing.cn/",
        name: "柯内特管理后台"
}]
const intellectualList = [
  {
    url: imgUrl.RY049,
    title: "RY049-质量管理系统认证证书（20251020-20281019）",
  }, {
    url: imgUrl.RY050,
    title: "RY050-职业健康安全管理系统认证证书（20251020-20281019）",
  }, {
    url: imgUrl.RY051,
    title: "RY051环境管理系统认证证书（20251020-20281019）",
  }, {
    url: imgUrl.RY052,
    title: "RY052安全生产标准化三级企业证书（20251222-20281222）",
  }, {
    url: imgUrl.intellectual22,
    title: "一种用于声音即气体敏感检测的系统",
    date: '2025-02'
  }, {
    url: imgUrl.intellectual21,
    title: "一种高性能气体传感器气敏催化材料负载方法机系统",
    date: '2025-01'
  }, {
    url: imgUrl.intellectual11,
    title: "知识产权管理体系认证证书",
    date: '2024-06'
  }, {
    url: imgUrl.intellectual12,
    title: "一种三维纳米管气体传感器阵列及其封装方法",
    date: '2023-09'
  }, {
    url: imgUrl.intellectual13,
    title: "一种气体传感器阵列及其打印溶液调制方法",
    date: '2023-08'
  }, {
    url: imgUrl.intellectual14,
    title: "一种基于环境变化的自启动净化装置",
    date: '2023-08'
  }, {
    url: imgUrl.intellectual15,
    title: "一种气体传感器阵列的打印控制方法及其打印装置",
    date: '2023-04'
  }, {
    url: imgUrl.intellectual16,
    title: "燃气报警器",
    date: '2023-04'
  }, {
    url: imgUrl.intellectual17,
    title: "空气质量检测仪",
    date: '2023-04'
  }, {
    url: imgUrl.intellectual18,
    title: "一种净化装置",
    date: '2022-11'
  },{
    url: imgUrl.intellectual19,
    title: "基于纳米纤维膜的空气质量监测传感器及监测系统",
    date: '2022-11'
  }, {
    url: imgUrl.intellectual20,
    title: "一种检测气体的校准方法及系统",
    date: '2022-10'
  }, {
    url: imgUrl.intellectual5,
    title: "一种校准装置",
    date: '2022-05'
  }, {
    url: imgUrl.intellectual1,
    title: "一种喷墨打印制备气体传感器阵列的方法",
    date: '2022-01'
  }, {
    url: imgUrl.intellectual4,
    title: "一种空气防尘管理系统及空气质量检测系统",
    date: '2021-11'
  }, {
    url: imgUrl.intellectual3,
    title: "一种小型自供电无线气体传感器盒及传感器阵列",
    date: '2021-05'
  }]
const honorList = [
  {
    url: imgUrl.honor15,
    title: "专精特新中小企业",
  }, {
    url: imgUrl.honor16,
    title: "广东省知识产权示范企业",
  }, {
    url: imgUrl.honor17,
    title: "佛山企业博士后工作站艾感科技（广东）有限公司分站",
  }, {
    url: imgUrl.honor18,
    title: "2024年度“扩投资稳增长突出贡献单位”",
  }, {
    url: imgUrl.honor12,
    title: "第二届佛山搞价值专利成果转移转化大赛",
  }, {
    url: imgUrl.honor11,
    title: "入围第十三届中国创新创业大赛2024光电产业领域专业赛(半决赛）",
  }, {
    url: imgUrl.honor4,
    title: "高新技术企业证书",
  }, {
    url: imgUrl.honor14,
    title: "第十三届中国创新创业大赛纳米产业技术创新专业赛全国总决赛全国总决赛成长企业组优秀企业奖",
  }, {
    url: imgUrl.honor13,
    title: "第九届“创客中国”广东市中小企业创新创业大赛暨第八届“创客广东”大赛企业组100强",
  }, {
    url: imgUrl.honor5,
    title: "2021“创客广东”佛山市中小企业创新创业大赛禅城区域一等奖",
  }, {
    url: imgUrl.honor3,
    title: "2021（第四届）广东高校科技成果转化路演大赛高教主赛道————电子信息组小组赛三等奖",
  }, {
    url: imgUrl.honor9,
    title: "2023年度禅城区最具创新力科技企业",
  }
]
const aqiList = [
  {
    name: "SO2",
    a: "0-150",
    b: "150-500",
    c: "500-650",
    d: "650-800",
    e: "800<",
    f: "无"
  }, {
    name: "NO2",
    a: "0-100",
    b: "100-200",
    c: "200-700",
    d: "700-1200",
    e: "1200-2340",
    f: "2340<"
  }, {
    name: "CO",
    a: "0-5",
    b: "5-10",
    c: "10-35",
    d: "35-60",
    e: "60-90",
    f: "90<"
  }, {
    name: "O3",
    a: "0-160",
    b: "160-200",
    c: "200-300",
    d: "300-400",
    e: "400-800",
    f: "800<"
  }, {
    name: "PM2.5",
    a: "0-35",
    b: "35-75",
    c: "75-115",
    d: "115-150",
    e: "150-250",
    f: "250<"
  }, {
    name: "PM10",
    a: "0-50",
    b: "50-150",
    c: "150-250",
    d: "250-350",
    e: "350-420",
    f: "420<"
  }, {
    name: "AQI",
    a: "0-50",
    b: "50-100",
    c: "100-150",
    d: "150-200",
    e: "200-300",
    f: "300<"
  }
]
const companyDetail = "2018年在佛山成立，是一家专注高质量气体传感器与电子鼻模组设计、研发、生产一体化的国家高新技术企业、专精特新中小企业，在纳米基材、气敏材料和芯片器件结构领域有20多年的产品研发与应用创新能力积累，致力于让机器拥有“嗅觉”感知世界，为各行业提供以嗅觉芯片为核心的智慧解决方案。联合创始人是2022年腾讯“科学探索奖”得主，其独创纳米蜂巢第三代半导体气体传感技术，单芯片可同时在线分析超1000种复杂气味。"

const teamlist=[
  {
    name: "范智勇 教授 Prof. Zhiyong Fan",
    job: "联合创始人 | 董事长",
    title: "联合创始人/董事长",
    url: imgUrl.team01,
    detail: [
      "香港科大电子与计算机工程系教授、化学和生物工程学系教授",
      "香港科大智能传感器中心 创始主任",
      "香港科大全国重点实验室 主任",
      "香港工程院院士、香港青年科学院创院院士、英国皇家化学会会士",
      "发表《Nature》、《自然·材料》等顶级期刊230+篇，全球高被引学者",
      "2024嗅觉芯片领域重大突破成果发表在顶级期刊"
    ],
    text: [
      "香港科技大学电子与计算机工程系/化学和生物工程学系双聘讲座教授、同时担任香港科技大学智能传感器中心创始主任、先进显示与光电子技术全国重点实验室联合主任，还是香港青年科学院院士及英国皇家化学会会士。",
      "其从事微纳电子及仿生领域研究20多年，在《自然》等国际顶刊发表了230余篇论文，学术引用超2.4万次，入选Clarivate “全球高被引学者”及“全球前2%顶尖科学家榜”（斯坦福全球学术引用研究）。2020年获“中国半导体十大进展”、2022年获腾讯“科学探索奖”。",
      "2018年他创建艾感科技（广东）有限公司，组建了一支由博士、教授、行业专家构成的核心团队，带领团队全球首创了基于三维多孔基底的大规模集成气体传感器芯片技术，凭借这一技术，他研发出“全球首款仿生嗅觉芯片”，使单芯片可集成10000个单元气体传感器阵列芯片，成为“世界最小电子鼻”的首发者。该成果同年被《自然·电子》（Nature Electronics）收录，开启了气体检测新纪元。"
    ]
  },   {
    name: "周清峰 教授 Prof.Qingfeng Zhou",
    job: "联合创始人 | 董事",
    title: "联合创始人/董事",
    url: imgUrl.team02,
    detail: [
      "中国科学技术大学本科，香港理工博士、香港科技大学博士后",
      "原合肥工业大学 特聘教授",
      "申请国际国内专利150+",
      "2023年获评广东省创业领军人才"
    ],
    text: [
      "本科毕业于中国科学技术大学，后赴美国克莱姆森大学、香港理工大学、香港科技大学和香港城市大学深造，分别取得硕士、博士学位，并完成博士后研究，是通信与信息系统领域的知名专家，兼具深厚的学术背景和创新创业的实战经验。其长期致力于物联网、5G/6G关键传输技术、及智能传感器等前沿领域的研究，发表论文近100篇，申请国际国内专利150余项。",
      "曾任合肥工业大学特聘教授、博士生导师。现任东莞理工学院特聘教授、南方科技大学和北京理工大学兼职导师。已培养硕士研究生20余名，博士研究生3名。",
      "主持多项国家级、省部级重点科研项目。参与多家科技企业的创办，精通科技创新项目管理和科技成果落地转化，2023年荣获“广东省高层次人才”。"
    ]
  },   {
    name: "薛峰 博士 Dr. Feng Xue",
    job: "执行董事长",
    title: "CEO",
    url: imgUrl.team03,
    detail: [
      "中国科学技术大学本科/硕士",
      "香港科技大学博士",
      "MEMS领域8年研发/从业经验",
      "发表高水平论文10余篇"
    ],
    text: [
      "拥有中国科学技术大学本科与硕士学位，并于香港科技大学取得博士学位，是兼具技术敏锐度与商业视野的高级管理人才。",
      "长期深耕MEMS核心技术研发，致力于前沿技术的创新与转化，拥有逾8年的研发与从业实战经验。且研究成果丰硕，已发表高水平学术论文10余篇，拥有扎实的理论功底。",
      "具备卓越的组织管理与战略执行能力，在求学期间曾担任中国科学技术大学学生会副主席、外联部部长。擅长资源整合、沟通协作与团队建设，现担任企业执行董事长（CEO），负责推动公司战略落地与高效执行，引领企业持续创新与发展。"
    ]
  },   {
    name: "万竹桉  博士 Dr. Zhu’an Wan",
    job: "首席技术官",
    title: "CTO",
    url: imgUrl.team04,
    detail: [
      "华中科技大学本科",
      "香港科技大学博士",
      "气敏材料，硬件电路，软件算法7年研发经验",
      "发表高水平论文及专利10余篇"
    ],
    text: [
      "本科毕业于华中科技大学光学与电子信息工程专业，后在香港科技大学电子与计算机专业深造，取得博士学位。在气敏材料、智能硬件及模式识别算法领域有逾7年的研发积淀，发表高水平论文及专利10余篇。曾获国家奖学金、全国大学生电子设计大赛一等奖，是兼具微纳气体传感器与智能硬件产品实战经验的复合型技术专家。",
      "现任艾感科技首席技术官（CTO），负责公司产品规划、设计、研发和技术指导管理工作，主导公司从芯片到应用的完整产品矩阵，多次带领研发团队在各领域开发创新产品，在智能安防、智慧家居、消费电子、食品医疗、康复养老等领域实现产品落地应用。"
    ]
  // },   {
  //   name: "赵健豪 博士 Dr.Jianhao Zhao",
  //   job: "首席运营官",
  //   title: "CCO",
  //   url: imgUrl.team05,
  //   detail: [
  //     "四川大学本科",
  //     "中国科学院上海微系统与信息技术研究所硕士",
  //     "香港科技大学电子与计算机工程博士",
  //     "超8年材料科学与硬件研发领域经验"
  //   ]
  }
]

const abilitylist = [
  {
    "blue-title": "30",
    "title": "余人研发团队",
    "text": "教授2名、博士5名，其他高层次人才约30人，专业涵盖电子信息工程、材料学、环境工程、化工生物、通信设备、智能硬件等领域"
  }, {
    "blue-title": "10%",
    "title": "营收投入研发",
    "text": "艾感科技坚持研发创新，10%营收投入研发，拥有超2000平米的研发实验室，研发配套设施2000万元"
  }, {
    "blue-title": "100+",
    "title": "研发成果及知识产权",
    "text": "国家高新技术企业，十余项国家级、省部级重点攻关项目，发明专利81项，通过ISO9001质量体系认证"
  }
]

const technologylist = [
  {
    title: "1.技术独特性",
    content: "全球唯一实现片内大规模气体传感器阵列集成，打破传统片外集成体积、性能限制",
    url: imgUrl.tech01
  }, {
    title: "2.超高集成密度",
    content: "集成万个气敏像素单元，单芯片可解析超1000种气体组分，实现复杂气味的数字化识别",
    url: imgUrl.tech02
  }, {
    title: "3.灵敏度优势",
    content: "灵敏度达ppb级（十亿分之一），一些需要高精度气体检测的场景也能适用",
    url: imgUrl.tech03
  }, {
    title: "4.提升稳定性",
    content: "利用原子层沉积技术控制膜厚精度，确保每个气敏单元的性能一致；配合独有加热丝设计，使功耗降低50%",
    url: imgUrl.tech04
  }
]

const placelist = [
  { text: "环境监测", url: imgUrl.placeIcon01,bgimg: imgUrl.placeBg01,
    detail: "通过智能嗅觉系统将气味信息数字化，实现对大气、室内、养殖及封闭等特定环境中各项气味组分的测定与浓度分析，以保障生态环境的安全与人们的健康生活。",
    content: [
      {
        url: imgUrl.placeEnvIcon01,
        name: "大气环境监测",
        text: "网格化监测和分析城市空气质量，及时发现、预警并溯源空气污染，对垃圾处理厂、化工园区等容易产生恶臭污染的场所，实现空气质量的高效治理。"
      }, {
        url: imgUrl.placeEnvIcon02,
        name: "室内环境监测",
        text: "深度解析室内空气污染物（如甲醛、TVOC）、物理参数（温湿度、PM2.5）及放射性物质等多重空气指标，并联动终端设备，实现室内环境的自动化、精细化管理。"
      }, {
        url: imgUrl.placeEnvIcon03,
        name: "养殖环境监测",
        text: "网格实时监测养殖场、畜禽舍的空气质量（如氨气、硫化氢、温湿度及二氧化碳等核心指标），智能调控风机、湿帘等设备，降低畜禽疫病风险。"
      }, {
        url: imgUrl.placeEnvIcon04,
        name: "封闭环境监测",
        text: "利用高精度传感阵列技术，对地铁、隧道、矿山、室内、冷链运输等密封空间进行空气质量、危害气体、污染气体的测定分析，确保空间内人员安全"
      }
    ] },
  { text: "智能家居", url: imgUrl.placeIcon02,bgimg: imgUrl.placeBg02,
    detail: "监测室内环境空气质量，识别、提醒可燃、有毒、有害气体，智能联动家庭设备，守护人身安全，提升生活品质。",
    content: [
      {
        url: imgUrl.placeHouseIcon01,
        name: "空气质量监测",
        text: "能实时检测室内场所的空气质量，包括PM2.5、CO、CO2、O2、O3、TVOC、甲醛、异味等指标，通过异味数值评估室内环境质量，监测系统还可联动新风系统自动调节空气质量。"
      }, {
        url: imgUrl.placeHouseIcon02,
        name: "智能油烟机",
        text: "通过监测空气中的TVOC（总挥发性有机物）、可燃气体以及异味分子浓度，来辅助判断烹饪状态，并根据油烟浓度自动调节烹饪吸力。"
      }, {
        url: imgUrl.placeHouseIcon03,
        name: "燃气探测",
        text: "可全天候不间断监测室内燃气浓度变化，一旦发生轻微泄露，自启动声光警示机制，并操控电磁阀关闭气源供应、驱动排风扇强力排风，避免燃气事故。"
      }, {
        url: imgUrl.placeHouseIcon04,
        name: "扫地机器人",
        text: "嗅觉系统结合AI算法识别家庭异味、报警，自启空气净化器、换新系统等，以及避障宠物粪便，避免二次污染；还能根据异味浓度，控制清洗剂用量。"
      }, {
        url: imgUrl.placeHouseIcon05,
        name: "冰箱食物腐败度检测",
        text: "搭载嗅觉芯片的冰箱，可以识别有机磷农药或甲苯等农残挥发信号，及精准判断食物的新鲜程度。一旦监测腐坏，立即在冰箱面板显示或推送给手机APP报警。"
      }, {
        url: imgUrl.placeHouseIcon06,
        name: "智能马桶",
        text: "检测智能马桶使用过程中的气体，如TVOC、恶臭气体等，同时结合阵列模块可实现糖尿病、肾脏疾病的早期筛查。"
      }, {
        url: imgUrl.placeHouseIcon07,
        name: "智能垃圾桶",
        text: "嗅觉芯片实时监测垃圾桶内硫化氢、氨气、TVOC等恶臭气体浓度，如达到预设阈值，系统会预警、将数据上传云端，并智能开启异味杀菌除臭装置。"
      }, {
        url: imgUrl.placeHouseIcon08,
        name: "智能空调新风系统",
        text: "实时捕捉空气中的异味、甲醛及TVOC等有害气体。系统据此自动调节风速、启停净化功能或切换内外循环，实现精准的空气质量智能管理。"
      }
 ] },
  { text: "智能监护", url: imgUrl.placeIcon03,bgimg: imgUrl.placeBg03,
    detail: "检测人体、宠物尿液、唾液、呼气等气味响应特征，结合物联网和人工智能技术，对生命体征、健康安全进行早期诊断和智能分析。",
    content: [
      {
        url: imgUrl.placeGuardIcon01,
        name: "失能/失禁者照护",
        text: "嗅觉芯片能敏锐捕捉尿液或粪便排出后的空气分子(如氨气、硫化氢)变化，将气味传感器贴附在纸尿裤外侧或集成在智能隔尿垫中，可实现秒级预警与及时护理，有效预防褥疮和泌尿系统感染。"
      }, {
        url: imgUrl.placeGuardIcon02,
        name: "科学喂养育儿",
        text: "婴儿消化记录仪或智能纸尿裤可嗅辨婴儿排泄和排气气味，判断消化状况。帮助月子中心、医院或家长科学育儿，及时发现消化不良、乳糖不耐受及菌群失衡等问题。"
      }, {
        url: imgUrl.placeGuardIcon03,
        name: "人体健康初筛",
        text: "便捷式口气分析仪、智能穿戴设备集成嗅觉芯片，通过分析人呼出气体中的挥发性有机物（VOCs），可实现肠道微生态、呼吸系统、糖尿病及幽门螺杆菌等疾病的居家便捷初筛。"
      }, {
        url: imgUrl.placeGuardIcon04,
        name: "宠物如厕管理",
        text: "宠物如厕异味散影响居家环境，将集成嗅觉芯片的除臭器搭载在普通猫砂盆上，秒变智能净味舱。根据异味浓度自启动净化、除臭功能，为主人和宠物营造清新的空间。"
      }, {
        url: imgUrl.placeGuardIcon05,
        name: "宠物疾病筛查",
        text: "宠物无法表达不适，搭载电子鼻系统的智能项圈、宠物专用呼气/尿液分析仪可捕捉尿路感染、膀胱炎或结石产生的特殊气味、生成健康报告，主人及时掌握宠物健康状况。"
      }, {
        url: imgUrl.placeGuardIcon06,
        name: "宠物饮食监测",
        text: "监测宠物的口气与排气气味，辅助判断消化吸收状况和饮食的适应性，避免因饮食不当导致的健康问题。"
      }
    ] },
  { text: "食品安全", url: imgUrl.placeIcon04,bgimg: imgUrl.placeBg04,
    detail: "检测和分析食品生产加工过程中的气味浓度变化，控制产品的存储、运输品质，有效降低运维成本。",
    content: [
      {
        url: imgUrl.placeFoodIcon01,
        name: "粮食贮存控制",
        text: "通过在粮仓中安装嗅觉芯片，对粮食的氧气和二氧化碳含量进行实时监测和控制，预防粮食霉变产生毒素（如黄曲霉素），或避免粮食变质腐烂。"
      }, {
        url: imgUrl.placeFoodIcon02,
        name: "仓储物流控制",
        text: "肉类与海鲜腐败会产生胺类、硫化氢等挥发性物质，在食品储存运输过程中，芯片可实时监测这些参数，精准判断肉类新鲜度，及时发现和解决问题。"
      }, {
        url: imgUrl.placeFoodIcon03,
        name: "酒水饮料风味鉴定",
        text: "在白酒、啤酒、咖啡或饮料行业，芯片可以精准区分“香型”，识别是否存在“杂味”。判断原料或发酵环境变化是否出现波动，确保每一批次产品的风味一致性。"
      }, {
        url: imgUrl.placeFoodIcon04,
        name: "生产环境监测",
        text: "在生产车间，芯片可以监测空气中是否存在特定的过敏原成分或清洁剂残留，确保生产环境的洁净度。"
      }, {
        url: imgUrl.placeFoodIcon05,
        name: "加工工艺优化",
        text: "食物在烘焙、发酵或烹饪过程中，芯片可以实时监测风味物质的生成情况，辅助调整温度、湿度和时间，确保产品口感的稳定性。"
      }, {
        url: imgUrl.placeFoodIcon06,
        name: "包材异味检测",
        text: "检测食品包装、塑料容器是否释放了有毒有害或有异味的挥发性有机物（VOCs），防止污染食品。还可以判断密封是否完好，避免漏气影响食品口感。"
      }, {
        url: imgUrl.placeFoodIcon07,
        name: "原料品质验收",
        text: "通过捕捉食物散发的特定“气味指纹”，可识别食品是否掺假，验证昂贵食材的真伪。"
      }, {
        url: imgUrl.placeFoodIcon08,
        name: "果蔬成熟度与催熟监测",
        text: "通过监测果蔬释放的乙烯等催熟气体，判断水果的成熟程度，帮助果农判断最佳的采摘、运输和销售时机。"
      }
    ] },
  { text: "汽车电子", url: imgUrl.placeIcon05,bgimg: imgUrl.placeBg05,
    detail: "微型传感器阵列融合AI算法，赋予汽车识别复杂气味的能力，可提升车内空气质量、增强行车安全和提供个性化交互体验。",
    content: [
      {
        url: imgUrl.placeCarIcon01,
        name: "酒驾监测",
        text: "分析驾驶员呼出气体中的酒精浓度，实时判断饮酒状态，一旦超标系统将联动车辆控制系统限制启动或发出警报，提升行车安全。"
      }, {
        url: imgUrl.placeCarIcon02,
        name: "车内空气质量监测",
        text: "实时捕捉甲醛、PM2.5、CO2、生活异味（食物味、霉味、烟味、宠物异味），自动联动新风设备净化空气，提升座舱舒适度与健康安全水平。"
      }, {
        url: imgUrl.placeCarIcon03,
        name: "疲劳监测",
        text: "分析驾驶员呼出气体中的VOC及体味变化，结合算法判断疲劳状态，并联动座舱系统释放提神香氛或发出警示，辅助保障驾驶安全。"
      }, {
        url: imgUrl.placeCarIcon04,
        name: "安全监测",
        text: "氢气传感器能敏锐感知电解液泄露的气味，在起火前预警；还能检测刹车片过热产生的焦糊味或线路短路的异味，预防机械故障。"
      }, {
        url: imgUrl.placeCarIcon05,
        name: "身份识别",
        text: "模拟警犬的嗅觉识别能力，根据驾驶员独特的体味特征来确认身份，实现无感解锁车辆、自动加载该用户的座椅、后视镜偏好设置。"
      }, {
        url: imgUrl.placeCarIcon06,
        name: "个性化出行体验",
        text: "根据用户喜好、驾驶模式、导航路线释放个性化香氛和浓度（如导航至海边释放海洋气息，运动模式配柑橘提神），打造愉悦出行体验。"
      }
    ] },
  { text: "具身智能", url: imgUrl.placeIcon06,bgimg: imgUrl.placeBg06,
    detail:"机器人搭载嗅觉芯片后，能更准确地检测电力设备和火灾现场的各种气体，提高巡检和救援的效率、安全性。",
    content: [
      {
        url: imgUrl.placeRobotIcon01,
        name: "安防巡检",
        text: "弥补了视觉无法看见无色危险物质的盲区，搭载嗅觉芯片的机器狗或机器人能像警犬一样识别毒品、炸药等危险品气味。适合机场、海关、车站、大型活动安保中的工作。"
      }, {
        url: imgUrl.placeRobotIcon02,
        name: "医疗健康",
        text: "闻诊机器人可通过人体呼出的气体或体味中的“气味指纹”，实现无创、无痛、便捷的早期疾病筛查；同时监测病房空气，识别细菌滋生、伤口感染的异味。"
      }, {
        url: imgUrl.placeRobotIcon03,
        name: "科普教育",
        text: "科研机器人利用嗅觉芯片分析土壤、水质和环境气体，助力生态农业研究。教育玩具机器人通过“闻”水果味，帮婴幼儿探索世界建立气味实物关联。"
      }, {
        url: imgUrl.placeRobotIcon04,
        name: "消防作业",
        text: "浓烟易导致人的视觉失效，消防机器人搭载的嗅觉芯片能穿透烟雾，通过气味地图快速定位火源、探测生命，生成最佳逃生路线。"
      }, {
        url: imgUrl.placeRobotIcon05,
        name: "环境与污染监测",
        text: "动态化网格监测放射性物质释放的有毒有害气体分子，实时绘制污染地图，评估环境健康风险。"
      }, {
        url: imgUrl.placeRobotIcon06,
        name: "家庭服务",
        text: "无论是食材的新鲜程度、居家的细微异味，还是危险的燃气泄漏，皆可被精准“嗅”出并客观量化，第一时间发出安全健康预警。"
      }
    ] },
  { text: "消费电子", url: imgUrl.placeIcon07,bgimg: imgUrl.placeBg07,
    detail:"嗅觉芯片的集成，可以让传统的智能手机、可穿戴设备等拥有环境感知和健康监测的新能力，为健康管理和生活方式产品开辟新思路。",
    content: [
      {
        url: imgUrl.placeCustomIcon01,
        name: "智能手机",
        text: "手机内置嗅觉传感器可以检测空气质量、有毒有害危险气体，给用户提供环境安全提示。同时，该技术还能应用于智能家电系统，实现全屋自动控制。"
      }, {
        url: imgUrl.placeCustomIcon02,
        name: "电子香氛",
        text: "通过检测室内异味情况自动调节香氛的浓度、释放量和频率，使香氛效果更为均匀和持久。"
      }, {
        url: imgUrl.placeCustomIcon03,
        name: "VR/AR娱乐配件",
        text: "在玩游戏或观看电影时，配合剧情发展，设备会释放出相应的气味（如森林的泥土味、战场的火药味、赛车的汽油味），极大增强沉浸感和代入感。"
      }, {
        url: imgUrl.placeCustomIcon04,
        name: "无感交互",
        text: "可应用于智能手环、智能手表等产品中，能方便识别盲盒内的物品（如通过气味区分红酒和橙子），或者在购物时提供更精准的商品信息、食品腐败信息。"
      }
    ] },
  { text: "石油化工", url: imgUrl.placeIcon08,bgimg: imgUrl.placeBg08,
    detail: "全天候、智能化、动态化监控危险气体的浓度变化，快速定位和溯源气味，保障企业生产安全。",
    content: [
      {
        url: imgUrl.placeCheIcon01,
        name: "有限空间危险气体检测",
        text: "可以检测塔、釜、罐、槽车以及管道中可能出现的危险气体、可燃气体，解决传统传感器误报、漏报，无法识别混合气体的问题。"
      }, {
        url: imgUrl.placeCheIcon02,
        name: "溯源定位",
        text: "通过探测有毒有害及可燃气体浓度，结合气象数据可计算泄露源头，提前发现阀门内漏、管道腐蚀或密封失效等早期故障，避免盲目搜寻。"
      }, {
        url: imgUrl.placeCheIcon03,
        name: "石油化工排放监测",
        text: "监测管道中气体的压力和流量，帮助企业实现工艺控制和节能降耗。例如，在工业生产中，通过检测气体流量和压力，可以实时掌握工艺参数并调整生产过程，从而提高生产效率和降低能耗。"
      }, {
        url: imgUrl.placeCheIcon04,
        name: "预警与应急联动",
        text: "嗅觉芯片集成到头盔或巡检仪中，会根据气体泄露浓度和危险等级，触发不同级别的预警信息，并上传数据至后台，助力人员精准掌控厂区安全。"
      }
    ] }
]

const aboutlist = [
  {
    "dec": "源自香港科技大学顶尖科研20多年行业经验沉淀",
    "num": "20",
    "unit": "+"
  }, {
    "dec": "3个研发中心配备近2000万的高端进口仪器、设备",
    "num": "2000",
    "unit": "万"
  }, {
    "dec": "技术研发团队荟聚行业专家、博士、高层次人才工程师",
    "num": "30",
    "unit": "+"
  }, {
    "dec": "搭载艾感科技的技术与产品赋能超过400个场景应用实践",
    "num": "400",
    "unit": "+"
  }, {
    "dec": "2024年扩大经营规模年产能3000万颗",
    "num": "3000",
    "unit": "万"
  }
]

const companyTimelist=[
  {
    year: "2018年",
    color: "#00D0FF",
    size: "small",
    url: imgUrl.about2018,
    text: [
      "企业在佛山成立，成为全球唯一可商用大规模气体传感器阵列芯片供应商",
      "授予“佛山市创新创业团队”称号",
      "入选广东高校科技成果转化中心孵化企业"
    ]
  }, {
    year: "2019年",
    color: "#00D0FF",
    size: "small",
    url: imgUrl.about2019,
    text: [
      "首创纳米蜂巢（NHC）第三代半导体工艺，奠定仿生嗅觉芯片技术基础",
      "推出首款NHC技术气体传感器阵列原型芯片"
    ]
  }, {
    year: "2020年",
    color: "#00D0FF",
    size: "normal",
    url: imgUrl.about2020,
    text: [
      "首款商用产品NHC单Pixel传感器模组投入量产",
      "联合创始人范智勇教授因嗅觉芯片技术获“中国半导体十大进展”"
    ]
  }, {
    year: "2021年",
    color: "#00D0FF",
    size: "normal",
    url: imgUrl.about2021,
    text: [
      "被认定为“国家高新技术企业”",
      "全球首发大规模片内阵列气体传感器，开发出全球首款高集成度“仿生嗅觉芯片”"
    ]
  }, {
    year: "2022年",
    color: "#00D0FF",
    size: "normal",
    url: imgUrl.about2022,
    text: [
      "联合创始人范智勇教授荣获腾讯“科学探索奖”及“首届中银香港科技创新奖”",
      "联合创始人周清峰教授入选“广东省创业领军人才计划”"
    ]
  }, {
    year: "2023年",
    color: "#00D0FF",
    size: "normal",
    url: imgUrl.about2023,
    text: [
      "获得清水湾基金战略投资",
      "联合创始人周清峰教授荣获“广东省高层次人才”奖"
    ]
  }, {
    year: "2024年",
    color: "#00D0FF",
    size: "normal",
    url: imgUrl.about2024,
    text: [
      "公司总部迁顺盈嘉科技产业园，年产能3000万颗",
      "授予“企业博士后工作站”认证",
      "完成Pre-A轮融资",
      "全球首发10000个单元的气体传感器阵列芯片，研发出全球“最小电子鼻”",
      "入选禅城区“聚光灯计划”，获政府背书加速产研融合"
    ]
  }, {
    year: "2025年",
    color: "#00D0FF",
    size: "normal",
    url: imgUrl.about2025,
    text: [
      "通过ISO9001质量体系认证",
      "通过ISO 14001环境管理体系认证",
      "通过ISO 45001环境管理体系认证",
      "获得安全生产标准化三级企业证书",
      "艾感子公司在深圳成立",
      "第50届日内瓦国际发明展，荣获金奖及特别贡献奖",
      "发明专利及其他技术成果共计81项",
      "产品矩阵扩展，推出N×N阵列嗅觉芯片",
      "集成式气体传感器模组大批量量产"
    ]
  }
]

const partnerlist = [
  {
    sort: 0,
    list: [
      imgUrl.partner01,
      imgUrl.partner02,
      imgUrl.partner03,
      imgUrl.partner04,
      imgUrl.partner05,
      imgUrl.partner17,
      imgUrl.partner18,
      imgUrl.partner28,
      imgUrl.partner29,
      imgUrl.partner30,
      imgUrl.partner31,
      imgUrl.partner32
    ]
  }, {
    sort: 1,
    list: [
      imgUrl.partner06,
      imgUrl.partner07,
      imgUrl.partner08,
      imgUrl.partner09,
      imgUrl.partner10,
      imgUrl.partner11,
      imgUrl.partner19,
      imgUrl.partner20,
      imgUrl.partner25,
      imgUrl.partner26,
      imgUrl.partner27
    ]
  }, {
    sort: 2,
    list: [
      imgUrl.partner12,
      imgUrl.partner13,
      imgUrl.partner14,
      imgUrl.partner15,
      imgUrl.partner16,
      imgUrl.partner21,
      imgUrl.partner22,
      imgUrl.partner23,
      imgUrl.partner24
    ]
  }
]

const videolist = [
  {
    videoUrl: "https://mqtt.aisensing.cn/video/猫砂盆除臭器.mp4",
    title: "智能猫砂盆",
    content: "“精准、智能、安全、省钱“清除养宠异味",
    coverImg: imgUrl.videoCover01
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/电子鼻赋能千行.mp4",
    title: "赋能千行",
    content: "艾感电子鼻加速多场景落地",
    coverImg: imgUrl.videoCover02
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/车载电子鼻.mp4",
    title: "车载电子鼻",
    content: "畅享呼吸自由",
    coverImg: imgUrl.videoCover03
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/电子鼻赋能具身智能.mp4",
    title: "具身智能感知突破",
    content: "艾感电子鼻开启'五感俱全'智能时代",
    coverImg: imgUrl.videoCover04
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/电子鼻嗅探机器人.mp4",
    title: "电子鼻智嗅未来",
    content: "智嗅未来：电子鼻引领感知技术革命",
    coverImg: imgUrl.videoCover05
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/企业介绍短视频.mp4",
    title: "艾感科技企业简介",
    content: "",
    coverImg: imgUrl.videoCover06
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/企业宣传片.mp4",
    title: "智嗅无界",
    content: "电子鼻赋能智慧新场景",
    coverImg: imgUrl.videoCover07
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/香港科技大学电子鼻宣传视频.mp4",
    title: "气味管家",
    content: "电子鼻智嗅未来的多元图景",
    coverImg: imgUrl.videoCover08
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/芯片洁净室.mp4",
    title: "无尘车间",
    content: "洁净室如何守护芯片良率？",
    coverImg: imgUrl.videoCover09
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/电子鼻.mp4",
    title: "从“盲测”到“智嗅”",
    content: "纳米蜂巢技术开启气体传感新纪元",
    coverImg: imgUrl.videoCover10
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/智能冰箱.mp4",
    title: "智能冰箱",
    content: "开启新鲜新时代",
    coverImg: imgUrl.videoCover11
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/智能猫砂盆小程序.mp4",
    title: "操作指南",
    content: "智能猫砂盆小程序操作指引",
    coverImg: imgUrl.videoCover12
  },{
    videoUrl: "https://mqtt.aisensing.cn/video/智能纸尿裤.mp4",
    title: "智能纸尿裤",
    content: "守护每一刻干爽与健康",
    coverImg: imgUrl.videoCover13
  }
]

const planList = [
  {
    type: '智能家居',
    id: "0",
    data: [
      {
        id: "001",
        name: "猫砂盆除臭器",
        dec: "猫砂盆除臭器",
        imgUrl: "catBox.png",
        styleType: 2,
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        detail: [{
          name: "方案背景",
          text: [
            "传统猫砂盆长期存在异味难除、细菌滋生、清理繁琐等问题，市场上现有的除臭方式（活性炭吸附、化学喷雾或臭氧杀菌）普遍存在效果短暂、安全性低、治标不治本等痛点。尤其在多猫家庭或封闭居住空间中，猫砂盆异味不仅影响生活品质，还可能引发人宠健康风险。因此，市场亟需一款能够实现“高效除臭、安全清新、人宠共安”的智能除臭解决方案。"
          ]
        }, {
          name: "方案概述",
          text: [
            "本方案基于智能异味传感器技术、物联网传输技术而打造，是一款专为传统猫砂盆设计的智能除臭器解决方案。除臭器设备可夹装或壁挂于各类开放式、封闭式或半开放式猫砂盆边缘，通过高精度异味传感器实时监测氨气、硫化氢等臭味分子浓度。当数值超过设定阈值时，自启高效排风系统，实现99%以上的除臭效率；支持APP远程控制、滤芯寿命提醒、运行模式自定义。"
          ]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: '智能感应',
              text: [
                "内置高灵敏度气体传感器“有味即启、无味待机”，精准识别气味波动，避免无效能耗，延长设备寿命。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '安全无害',
              text: [
                "不产生有害挥发物，材料符合宠物用品安全标准，孕妇与过敏体质人群亦可安心使用。"
              ],
              imgurl: "adv-icon04.png"
            }, {
              title: '低噪静音设计',
              text: [
                "运行噪音接近低声说话环境音，不惊扰猫咪如厕行为，保障其心理安全感。"
              ],
              imgurl: "adv-icon03.png"
            }, {
              title: '耗材更换提醒',
              text: [
                "小程序实时提醒用户耗材的更换周期，降低用户维护成本。"
              ],
              imgurl: "adv-icon01.png"
            }
          ]
        }, {
          name: "方案价值",
          valuelist:[
            {
              title: '清理减负',
              text: [
                "降低根除异味成本；轻松实现科学养宠"
              ],
              imgurl: "plan004-1.png"
            }, {
              title: '避免异味交叉',
              text: [
                "解决气味累积问题；保障多猫环境的卫生"
              ],
              imgurl: "plan004-2.png"
            }, {
              title: '精细化护理',
              text: [
                "减少有害气体刺激宠物；降低宠物患病风险"
              ],
              imgurl: "plan004-4.png"
            }, {
              title: '定制化服务',
              text: [
                "提供个性化除臭模组；助力产品差异化竞争"
              ],
              imgurl: "plan004-3.png"
            }
          ]
        }, {
          name: "应用场景",
          imgUrl: "catBox-demo.png"
        }]
      }, {
        id: "002",
        name: "食物新鲜度监测系统",
        dec: "食物新鲜度监测系统",
        imgUrl: "food.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [
          {
            name: "方案背景",
            text: ["联合国环境规划署发布《2024年食物浪费指数报告》指出，全球浪费的食物总量超10亿吨，因食物浪费腐坏造成的温室气体排放量占全球年度排放量的8%至10%，持续加剧气候变化、自然环境丧失和污染。其中，因储存不当或判断失误导致的变质占食物浪费重要比例。在此背景下，艾感科技推出食物新鲜度智能监测系统解决方案，融合AI视觉、多模态传感与物联网技术，智能判断食材状态，降低食物浪费。"]
          }, {
            name: "方案概述",
            text: ["艾感研发的食物新鲜度智能监测系统，是一套集“传感感知—智能分析—终端预警”于一体的全栈式解决方案。它融合多维生物传感、物联网、AI 算法与区块链技术，构建了“产地—仓储—物流—零售—家庭”的全链条监测网络，可以实现对果蔬、肉类、水产、粮油等多品类食物的实时、无损、精准监测。无论是工业产线的高速分拣，还是家庭冰箱的日常管理，系统均可提供定制化模块。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '多模态感知融合',
                text: [
                  "系统整合AI视觉识别腐败斑点、气体传感器捕捉挥发性有机物（VOCs）、温湿传感器监控储存环境，多维度交叉验证，误报率低。"
                ],
                imgurl: "adv-icon03.png"
              }, {
                title: '全场景自适应能力',
                text: [
                  "支持工业级高速检测与消费级便捷使用。工业端可集成至生产线，实现每分钟数百件的实时分拣；消费端通过智能厨电设备与小程序，让用户随时掌握食材新鲜状态。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: 'AI算法动态预警',
                text: [
                  "搭载自研新鲜度预测模型，基于历史数据与环境参数，预测食材未来的腐烂趋势，提前推送“临期预警”与“保鲜建议”。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '无损检测与低成本部署',
                text: [
                  "无需破坏食材，通过非接触式嗅觉传感模组即可完成检测；兼容现有设施，模组采用阵列化、微型化设计，部署成本低。"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '降本增效',
                text: [
                  "将人工分拣成本降低60%，检测效率提升数十倍；通过精准预警减少食物浪费"
                ],
                imgurl: "plan002-2.png"
              }, {
                title: '安全可控',
                text: [
                  "数据科学量化食材新鲜度，降低食材误判率；有效拦截不合格食材，避免食源性疾病"
                ],
                imgurl: "plan001-4.png"
              }, {
                title: '产业升级',
                text: [
                  "为食品产业和监管部门提供标准化、数字化的品控工具；推动行业智能化升级"
                ],
                imgurl: "plan001-1.png"
              }, {
                title: '可持续发展',
                text: [
                  "降低因食材腐烂产生的温室气体排放，助力“碳达峰”与“碳中和”目标的实现"
                ],
                imgurl: "plan011-4.png"
              }
            ]
          }, {
            name: "应用场景",
            imgUrl: "food-flash-demo.png"
          }
        ]
      }, {
        id: "003",
        name: "家用燃气报警器",
        dec: "家用燃气报警器",
        imgUrl: "gas.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [
          {
            name: "方案背景",
            text: ["随着城市化进程的加快和居民生活水平的提升，家庭用气安全已成为社会关注的焦点。据统计，每年因燃气泄漏引发的火灾、爆炸事故屡见不鲜，严重威胁人民群众的生命财产安全。为有效防范此类风险，我司结合物联网、智能传感与自动控制技术，推出“智慧家安”家用燃气报警器整体解决方案。本方案以“主动预警、智能联动、远程可控、长效稳定”为核心，构建全天候的家庭燃气安全防护体系。"]
          }, {
            name: "方案概述",
            text: ["本燃气安全解决方案采用高精度气体传感、物联网通信与智能控制技术，系统由智能燃气报警器、无线联动阀门（电磁阀/机械手）、通信网关及云管理平台组成，可实时监测家庭、商铺、工厂等场所的天然气（CH₄）、液化石油气（LPG）、人工煤气等可燃气体泄漏情况。当气体浓度达到预设报警值，设备立即触发声光报警，并通过NB-IoT/Wi-Fi/4G等网络将报警信息实时推送至用户手机APP、管理平台及应急指挥中心，同时联动关闭燃气阀门切断气源，预防燃爆事故，满足居民用户“主动防护”与监管部门“可视可控”的双重需求。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '仿生嗅觉，精准识别',
                text: ['艾感第三代半导体三维多孔结构，吸附性强，能预警ppb级微量泄漏。'],
                imgurl: "adv-icon01.png"
              }, {
                title: '阵列传感，AI 算法',
                text: ['抗干扰、不误报，有效区分燃气与油烟、水汽，稳定性强。'],
                imgurl: "adv-icon02.png"
              }, {
                title: '高度集成，节能耐用',
                text: ['设备体积小，安装灵活易部署。功耗低寿命长，避免频繁维护。'],
                imgurl: "adv-icon03.png"
              }, {
                title: '智能联动，安全防护',
                text: ['支持本地声光报警、手机远程提醒，可联动电磁阀、排风扇实现自动处置。'],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: "高性能",
                text: [
                  "多种气源识别；精准检测误报率低"
                ],
                imgurl: "plan001-1.png"
              }, {
                title: "高可用",
                text: [
                  "自动切断装置；联动新风系统"
                ],
                imgurl: "plan001-2.png"
              }, {
                title: "高体验",
                text: [
                  "可多方绑定小程序；声光预警与个性化提醒"
                ],
                imgurl: "plan001-3.png"
              }, {
                title: "高可靠",
                text: [
                  "防拆、防爆多重防护；符合3C与CJ/T标准"
                ],
                imgurl: "plan001-4.png"
              }
            ]
          }, {
            name: "应用场景",
            imgUrl: "gas-demo.png"
          }
        ]
      },  {
        id: "004",
        name: "口气监测仪",
        dec: "口气监测仪",
        imgUrl: "Breath-monitoring-device.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [{
          name: "方案背景",
          text: ["口气问题在社交中会影响个人形象与自信心的隐形障碍。传统判断方式依赖主观感受，缺乏科学依据，易造成社交尴尬或心理焦虑。本方案旨在通过高精度口气监测仪，为用户提供客观、量化的口气健康数据，解决“假性口臭焦虑”与“隐性口臭忽视”两大痛点。产品面向注重生活品质的个人用户、口腔护理机构及健康管理平台，满足家庭自测、临床辅助诊断、健康数据追踪等多元化场景需求。"]
        }, {
          name: "方案概述",
          text: ["本方案设备基于纳米蜂巢（NHC）第三代半导体传感器、气相色谱检测及智能算法技术，可精准识别呼吸中硫化氢、甲硫醇等异味气体浓度。用户仅需对准采样口平稳呼气5秒，即可快速生成口气等级、气体浓度值及建议社交距离三项核心数据。通过蓝牙模块与手机APP连接，自动同步检测记录，生成口气变化趋势图，支持饮食、口腔护理行为与口气数据的关联分析。方案覆盖硬件终端、软件平台及云端数据分析服务。"]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: 'AI仿生嗅觉识别',
              text: [
                "可识别0.1ppm级硫化氢与甲基硫醇浓度，结合温度湿度补偿算法，区分不同类型的口腔异味，而非仅检测单一气体浓度。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '非侵入式检测',
              text: [
                "采用无创呼气检测方式，无需采血或复杂准备，配备一次性采样嘴，确保卫生安全，提升用户接受度。"
              ],
              imgurl: "adv-icon01.png"
            }, {
              title: '数字化分析预警',
              text: [
                "将气味信息转化为可视化数字报告，支持小程序评估口气程度，分析口腔健康趋势，提供护理建议。"
              ],
              imgurl: "adv-icon04.png"
            }, {
              title: '微小体积易集成',
              text: [
                "基于小型化、低功耗的嗅觉芯片技术，设备可轻松集成到其他智能健康设备中，方便日常随身使用。"
              ],
              imgurl: "adv-icon03.png"
            }
          ]
        }, {
          name: "方案价值",
          valuelist:[
            {
              title: '辅助诊断',
              text: [
                "辅助牙周病、口臭病因筛查；提前预警口腔或全身性疾病风险"
              ],
              imgurl: "plan002-1.png"
            }, {
              title: '专业提升',
              text: [
                "打破“感知盲区”，减少判断误差；数据量化口气健康，科学护理"
              ],
              imgurl: "plan002-2.png"
            }, {
              title: '易于开发',
              text: [
                "标准化数据接口，兼容业界生态；精准预测，拓展口腔健康服务生态"
              ],
              imgurl: "plan002-3.png"
            }
          ],
        }, {
          name: "应用场景",
          imgUrl: "Breath-demo.png"
        }]
      },  {
        id: "005",
        name: "空气检测盒子",
        dec: "空气检测盒子",
        imgUrl: "airTestBox.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [{
          name: "方案背景",
          text: ["空气质量是影响人们生活品质与身体健康的重要因素，单纯依靠个人的主观感受来判断空气质量，缺乏科学依据。且国家对环境保护与公共健康监管严格，不断倒逼各行业向绿色、智能、可持续方向发展。因此，家庭用户、企事业单位及城市管理者迫切需要一套“精准、智能、高效”的空气监测体系解决方案。"]
        }, {
          name: "方案概述",
          text: ["本方案基于高精度传感器技术、物联网传输与AI数据分析，实时监测室内场所的空气质量，包括PM2.5、CO、CO2、O2、O3、TVOC、甲醛、异味等多种参数指标的实时监测。通过智能终端采集数据，实现空气质量的可视化、预警化、智能化管理。同时监测系统还可与园区新风系统、空气净化设备等联动，实现自动调节。"]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: '高精度多参数监测',
              text: [
                "实时监测室内空气质量，包括PM2.5、CO、CO2、O2、O3、TVOC、甲醛等污染物浓度，响应快、稳定性强。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '全场景数据可视化',
              text: [
                "平台支持实时数据曲线、历史趋势图展示，支持生成空气质量报告，帮助用户科学评估环境空气。"
              ],
              imgurl: "adv-icon03.png"
            }, {
              title: '智能预警与联动控制',
              text: [
                "支持自定义报警阈值，当监测到空气污染事件时，自动触发声光报警通知用户。可联动空气净化器、新风系统、空调等设备。"
              ],
              imgurl: "adv-icon01.png"
            }
          ]
        }, {
          name: "方案价值",
          valuelist:[
            {
              title: '改善呼吸环境',
              text: [
                "精准识别室内污染；营造老幼孕敏感人群健康环境"
              ],
              imgurl: "plan003-1.png"
            }, {
              title: '优化办公品质',
              text: [
                "降低病假率；打造绿色健康企业文化"
              ],
              imgurl: "plan003-2.png"
            }, {
              title: '提升管理质量',
              text: [
                "满足监管要求，树立品牌形象；增强客户信任感"
              ],
              imgurl: "plan003-3.png"
            }, {
              title: '推动生态建设',
              text: [
                "助力城市管理者溯源污染；提升应急响应、科学决策效率"
              ],
              imgurl: "plan003-4.png"
            }
          ],
        }, {
          name: "应用场景",
          imgUrl: "air-demo.png"
        }]
      }
    ]
  }, {
    type: '环境监测',
    id: "1",
    data: [
      {
        id: "011",
        name: "恶臭在线监测系统",
        dec: "恶臭在线监测系统",
        imgUrl: "hanlan.png",
        styleType: 2,
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        detail: [{
          name: "方案背景",
          text: ["恶臭气体具有浓度低、嗅阈值低、组分复杂、瞬时性强、扩散快等特点，主要含硫化氢、氨气、甲硫醇、三甲胺及挥发性有机异味等，危害环境与人体健康。目前恶臭管控存在瓶颈：人工嗅辨主观、无法连续监测，实验室分析难以捕捉无组织、间歇性排放；多源混合气味干扰大，溯源、量化、取证、管控难度高。建设智能化、网络化、高精度恶臭监测系统，成为企业合规运营、政府精准执法与社区和谐共治的刚需。"]
        }, {
          name: "方案概述",
          text: ["本方案基于多参数气体传感技术、物联网（IoT）、云计算与大数据分析，7×24小时实时监测、精准识别、定量分析、自动预警氨气、硫化氢、三甲胺、甲硫醇、VOCs等十余种恶臭因子，结合气象参数（温湿度、风速、风向、大气压）溯源污染。监测数据通过4G/5G/NB-IoT等通信方式实时上传至云端管理平台，支持PC端、移动端多屏查看，实现超标自动报警、趋势预测、数据报表生成与远程设备控制。系统适应高温、高湿、高尘等复杂工业环境，全面提升恶臭治理精细化、数字化、科学化水平。"]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: '多参数灵敏监测',
              text: [
                "检测限达ppb级，支持同时监测十多种恶臭气体，数据精准稳定，支持定制气体传感器。"
              ],
              imgurl: "adv-icon01.png"
            }, {
              title: '智能预警与联动',
              text: [
                "可自定义报警阈值，当浓度超标，系统触发声光报警，并推送给管理人员。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '全天候稳定运行',
              text: [
                "内置温湿度补偿、自动校准等预处理系统，支持-20℃~+50℃宽温工作，IP65防护等级，适应恶劣环境。"
              ],
              imgurl: "adv-icon03.png"
            }, {
              title: '数据可视化追溯',
              text: [
                "平台支持实时数据曲线、历史趋势图、热力分布图等多种展示形式，满足监管与审计需求。"
              ],
              imgurl: "adv-icon04.png"
            }
          ]
        }, {
          name: "方案价值",
          valuelist:[
            {
              title: '助力合规排放',
              text: [
                "降低环保风险与投诉率；降低企业能耗、治理成本"
              ],
              imgurl: "plan011-1.png"
            }, {
              title: '优化链路溯源',
              text: [
                "精准实时数据，强化治理；支持污染溯源、应急响应决策"
              ],
              imgurl: "plan011-2.png"
            }, {
              title: '提升生活质量',
              text: [
                "减少恶臭对居民生活的干扰；构建企业与社区的和谐关系"
              ],
              imgurl: "plan011-3.png"
            }, {
              title: '可持续发展',
              text: [
                "推动环境监测数字化转型；助力绿色生态文明建设"
              ],
              imgurl: "plan011-4.png"
            }
          ],
        }, {
          name: "应用场景",
          imgUrl: "hanlan-demo.png"
        }]
      },  {
        id: "012",
        name: "AGKJ-011-AQI微型监测站",
        dec: "AGKJ-011-AQI微型监测站",
        imgUrl: "monitors.png",
        styleType: 2,
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        detail: [{
          name: "方案背景",
          text: ["传统大型监测站虽数据精准，但存在建设周期长、成本高、布点受限、运维复杂等问题，难以覆盖乡镇、园区、街道等“最后一公里”场景。基层环保部门、工业园区、城市管理者面临污染溯源难、应急响应慢、数据支撑不足等挑战。微型监测站应运而生，以其“小体积、大能力”的特点，成为构建全域感知网络的关键节点，助力实现环境管理的数字化转型。"]
        }, {
          name: "方案概述",
          text: ["本微型监测站方案一体化集成多通道气体传感阵列、精准气象监测、边缘智能算法与无线传输模块，可精准监测颗粒物（PM2.5/PM10）、气体（SO₂、NO₂、O₃、CO、VOCs）、水质（pH、溶解氧、浊度、氨氮）、气象（温湿度、风速、风向、气压）等多项指标。数据通过4G/NB-IoT无线网络实时上传至云平台，支持超标自动报警、多级预警、短信/APP推送，助力快速响应与科学决策。设备安装灵活、维护简便，适用于工业园区、厂界、垃圾站、污水站点、社区等多场景网格化布控，为环境治理、合规监管提供轻量化、智能化、高性价比的一站式监测解决方案。"]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: '多参数集成监测',
              text: [
                "同步监测气体污染物、颗粒物、气象环境等十余项参数，全方位感知空气质量，满足不同场景的监测需求。"
              ],
              imgurl: "adv-icon01.png"
            }, {
              title: '智能补偿',
              text: [
                "艾感自研纳米蜂巢阵列传感器，结合温湿度补偿、交叉干扰校正、动态标定等智能算法，确保数据稳定性与趋势准确性。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '智能预警',
              text: [
                "内置边缘计算能力，可对数据进行本地化预处理分析，检测异常或超标时迅速预警，助力污染溯源与应急处理。"
              ],
              imgurl: "adv-icon03.png"
            }, {
              title: '开放兼容',
              text: [
                "支持HJ-212、Modbus等标准协议，可对接政府监管平台、智慧城市大脑、企业EHS系统，避免数据孤岛，实现多系统联动。"
              ],
              imgurl: "adv-icon04.png"
            }
          ]
        }, {
          name: "方案价值",
          valuelist:[
            {
              title: '数据化管理',
              text: [
                "低成本构建全域监测网络；污染溯源分析与治理效果评估"
              ],
              imgurl: "plan012-1.png"
            }, {
              title: '助力合规生产',
              text: [
                "全天候监控厂界与排放；风险预警，降低环保事故与投诉"
              ],
              imgurl: "plan012-2.png"
            }, {
              title: '精细化治理',
              text: [
                "快速处置扬尘、异味等民生污染；增强公众满意度与城市形象"
              ],
              imgurl: "plan012-3.png"
            }
          ]
        }, {
          name: "应用场景",
          imgUrl: "AGKJ-demo.png"
        }]
      }
    ]
  }, {
    type: '康养护理',
    id: "2",
    data: [
      {
        id: "021",
        name: "智能纸尿裤监测系统",
        dec: "智能纸尿裤监测系统",
        imgUrl: "Intelligent-Diaper-Monitoring-System.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        introduction: [
          {
            name: "介绍",
            text: ["艾感科技智能纸尿裤监测设备，专为解决传统纸尿裤护理滞后与隐私痛点而打造。它融合硫化氢、温湿度传感器技术，精准监测排泄、湿度及体温变化，"+
                "APP秒级推送提醒，让护理更及时，有效减少皮肤隐患，守护被照护者的健康与尊严。设备可重复使用、寿命长，监测灵敏抗干扰，卡扣式设计小巧便携，"+
                "搭配声音报警实现 24 小时守护，适用于失能成人、住院患者、卧床老人等场景，为专业照护与家庭陪护提供安心之选。"]
          }
        ],
        detail: [
          {
            name: "方案背景",
            text: ["全球老龄化加剧、精细化护理需求提升，传统纸尿裤“被动感知、更换滞后”的特点，已难以满足失能群体、婴幼儿及术后患者的健康护理需求。长期使用潮湿纸尿裤，易引发尿布疹、皮肤溃烂、尿路感染等健康风险，而频繁人工检查则存在侵犯隐私、增加护理负担、夜间响应不及时等问题。在此背景下，艾感科技智能纸尿裤监测系统应运而生，深度融合物联网与AI算法技术，为精细智能化护理提供技术支撑。"]
          }, {
            name: "方案概述",
            text: ["智能纸尿裤监测系统是一套集“生理监测、智能预警、数据管理”于一体的解决方案，由智能纸尿裤、可拆卸传感模块、移动终端应用与云端管理平台构成。集成了高精度异味传感器与温湿度传感器，可实时捕捉纸尿裤尿液浸润面积及体表温度波动；当数值超过预设阈值时，系统自动触发预警，通过低功耗蓝牙，将更换提醒和健康预警等信息，传输至护理人员手机。同时，系统终端可生成排泄规律分析，提供护理建议。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '无感监测',
                text: [
                  "设备采用柔性亲肤材质，厚度仅0.7cm，嵌入纸尿裤后不影响透气性与吸水性，老人与婴幼儿穿戴无异物感。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: '精准预警',
                text: [
                  "湿度检测误差＜5%，体温监测精度±0.1℃，结合AI算法可区分尿液与粪便，避免误报漏报。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '隐私保护',
                text: [
                  "系统通过数据化提醒替代人工频繁观察，让护理更体面、更有温度。"
                ],
                imgurl: "adv-icon03.png"
              }, {
                title: '数据驱动',
                text: [
                  "自动生成排泄规律、体温曲线等健康数据，支持家属和护理员的多方设备远程联动查看护理状态。"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "产品展示",
            imgUrl: "darper_detail.png"
          }, {
            name: "应用场景",
            imgUrl: "darper_demo.png"
          // }, {
          //   name: "产品参数",
          //   table: {
          //     header: ["参数名称", "数值"],
          //     body: [
          //       {"参数名称": "产品名称", "数值":"大小便监测设备"},
          //       {"参数名称": "产品颜色", "数值":"白色"},
          //       {"参数名称": "功能", "数值":"尿湿与排便监测"},
          //       {"参数名称": "供电方式", "数值":"磁吸式充电"},
          //       {"参数名称": "主要材质", "数值":"亲肤塑料"},
          //       {"参数名称": "充电时间", "数值":"1h可充满"},
          //       {"参数名称": "产品尺寸", "数值":"47×35×7mm"},
          //       {"参数名称": "续航时间", "数值":"24h"},
          //     ]
          //   }
          }
        ]
      }
    ]
  }, {
    type: '工业安全',
    id: "3",
    data: [
      {
        // ##################################################
        id: "031",
        name: "六合一气体监测模块",
        dec: "六合一气体监测模块",
        imgUrl: "6to1.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [
          {
            name: "方案背景",
            text: ["地下管廊、工业厂房、以及智慧城市基础设施，常常面临多种有害气体共存的挑战。传统气体监测方案长期面临三大痛点：单一传感器碎片化部署成本高、多气体交叉干扰影响检测精度、缺乏智能化分析能力。艾感科技基于自主研发的纳米蜂巢（NHC）半导体气体传感技术与AI气味算法，推出六合一气体监测模块，为工业安全与智慧生活提供数字化嗅觉解决方案。"]
          }, {
            name: "方案概述",
            text: ["艾感科技六合一气体监测模块是基于NHC-nose技术打造的复合气体感知系统，通过集成六个独立气体传感单元与智能分析算法，可同时监测可燃气体、有毒气体及挥发性有机物等六类关键指标，另外可选配三甲胺、甲硫醇、甲硫醚、二甲二硫、二硫化碳、苯乙烯等恶臭指标以及PM2.5、PM10、温度、湿度等环境指标。深度学习算法实现ppb级浓度捕捉和快速响应，精准构建环境气味图谱。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '高集成度与微型化',
                text: [
                  "三维纳米阵列结构设计，将六种气体检测功能集成于单一芯片，体积微小，功耗低。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: 'AI驱动精准识别',
                text: [
                  "内置自主研发的深度学习算法，消除多气体交叉干扰，实现对混合气体的独立成分分析。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '模块化设计与低成本',
                text: [
                  "采用标准化接口与模块化架构，支持灵活扩展与快速更换，量产成本较传统阵列传感器下降50%。"
                ],
                imgurl: "adv-icon03.png"
              }, {
                title: '国际认证的技术',
                text: [
                  "核心技术获日内瓦国际发明展金奖，产品性能通过化工、环保等严苛场景验证。"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '工业安全防御',
                text: [
                  "预警化工园区、石化基地等场景可燃气体、有毒有害气体泄露，预防事故"
                ],
                imgurl: "plan011-1.png"
              }, {
                title: '环保治理管控',
                text: [
                  "助力环保企业实现精准治污与节能降耗，满足日益严格的环保排放标准"
                ],
                imgurl: "plan011-2.png"
              }, {
                title: '终端体验升级',
                text: [
                  "集成于智能家电、新能源汽车等设备，赋予其“数字化嗅觉”能力，提升用户生活品"
                ],
                imgurl: "plan011-3.png"
              }, {
                title: '降低综合成本',
                text: [
                  "模块化、免校准设计及标准化接口，即插即用，节省下游企业研发和运维成本"
                ],
                imgurl: "plan011-4.png"
              }
            ],
          }, {
            name: "应用场景",
            imgUrl: "6to1_demo.png"
          }, {
            name: "产品参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "产品名称", "数值":"六合一气体传感器模组"},
                {"参数名称": "检测气体", "数值":"二氧化碳、氢气、硫化氢、一氧化碳、挥发性有机物、甲烷"},
                {"参数名称": "量程", "数值":"CO2:5000PPM， O2:30%V01，H2S:500PPM，CO:1000PPM，TVOC:200PPM，CH4:20%LEL"},
                {"参数名称": "分辨率", "数值":"0.1ppm"},
                {"参数名称": "精度", "数值":"±3%FS"},
                {"参数名称": "供电电源", "数值":"DC:3v~5v"},
                {"参数名称": "信号输出", "数值":"RS485"},
                {"参数名称": "进气流量", "数值":"1L/min"},
                {"参数名称": "工作环境", "数值":"-25℃＋50℃"}
              ]
            }
          }
        ]
      }, {
        // ##################################################
        id: "032",
        name: "智能安全头盔帽",
        dec: "智能安全头盔帽",
        imgUrl: "cap.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [          
          {
            name: "方案背景",
            text: ["建筑施工、矿山开采、电力巡检、石油化工等场景中，作业环境复杂多变，存在有毒气体泄漏、人员跌倒、违规脱帽、突发疾病及通信盲区等多重风险。而传统安全帽仅具备物理、被动防护功能，难以满足工业4.0智能化时代高危行业人员的作业需求。因此，打造一款具备主动预警、实时感知与高效协同能力的智能安全头盔，是保障作业人员生命安全、提升企业数字化管理水平的关键举措。"]
          }, {
            name: "方案概述",
            text: ["艾感科技智能安全帽头盔是一款主动感知环境风险并预警的工业级智能终端，采用人体工学设计，符合GB2811-2019安全帽标准。除具有较强的抗冲击功能外，还具备语音通信、影像采集、无线传输、气味识别等功能，并在强噪音环境仍能非常清晰的发话收听，实现将现场情况实时反馈到远端，真正意义上解放双手，同时具有高清视频采集、语音通讯对讲、危险源检测预警、本地存储等功能，适用于火灾现场的抢险救援、通信指挥和应急会商等。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '智能安全预警',
                text: [
                  "ppb级微量泄漏识别与报警，同时，能够对作业人员疲劳状态、心率异常等潜在风险进行智能预警。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: '多场景通信',
                text: [
                  "多重定位技术，支持Mesh自组网，头盔可自动中继信号构建临时通信网络，确保指令畅通。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '坚固耐用',
                text: [
                  "IP66级防水，可耐受-20℃至50℃的极端温度环境，适应潮湿、粉尘、撞击等恶劣工况。"
                ],
                imgurl: "adv-icon03.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '重塑安全防线',
                text: [
                  "将传统的“事后救援”转为“事前干预”，缩短应急响应时间，降低事故发生率"
                ],
                imgurl: "plan011-1.png"
              }, {
                title: '优化流程',
                text: [
                  "通过人员实时定位、语音通信功能，管理者随时掌握作业路径，优化调度指挥"
                ],
                imgurl: "plan011-2.png"
              }, {
                title: '提升管理效能',
                text: [
                  "所有音视频数据、报警记录与环境参数均可云端存储，助力企业构建安全管理"
                ],
                imgurl: "plan011-3.png"
              }
            ],
          }, {
            name: "应用场景",
            imgUrl: "cap_demo.png"
          }, {
            name: "产品功能",
            imgUrl: "cap_detail.png"
          }, {
            name: "产品参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "内存", "数值":"PAM 3GB＋ROM 32GB"},
                {"参数名称": "定位", "数值":"GPS/北斗"},
                {"参数名称": "麦克风", "数值":"双降噪麦克风"},
                {"参数名称": "蓝牙wifi", "数值":"BT 4.14 LE WIFI 802.11b/g/n"},
                {"参数名称": "功能", "数值":"撞击报警、温度报警、静默报警、紧急呼救"},
                {"参数名称": "手电筒", "数值":"支持"},
                {"参数名称": "规格尺寸", "数值":"301*228*149mm"},
                {"参数名称": "重量", "数值":"650g"},
                {"参数名称": "软件平台", "数值":"ANDROID 10.0"},
                {"参数名称": "摄像头", "数值":"1600万高清摄像头"},
                {"参数名称": "电池容量", "数值":"5000mAh"},
                {"参数名称": "防护等级", "数值":"IP66"},
                {"参数名称": "单卡", "数值":"Mirco Sim卡"},
                {"参数名称": "频段", "数值":"4G全网通"}
              ]
            }
          }
        ]
      }, {
        // ##################################################
        id: "033",
        name: "工业燃气报警器",
        dec: "工业燃气报警器",
        imgUrl: "alarm-equipment.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [
          {
            name: "方案背景",
            text: ["工业场景燃气泄露往往量大、气体浓度高、救援环境恶劣，一旦气体浓度达到爆炸极限，后果往往是灾难性的。传统的工业燃气报警器虽然在一定程度上发挥了作用，但仍面临传感器易中毒老化、响应速度滞后、误报漏报频发以及运维成本高昂等痛点。特别是在《安全生产法》等法规日益严格的背景下，企业亟需一款能够实现事前预警、本质安全且智能化的燃气监测设备，筑牢安全防线。"]
          }, {
            name: "方案概述",
            text: ["艾感科技工业燃气报警器是一款专为严苛工业环境设计的本质安全型监测设备。该方案深度融合了艾感科技自研的纳米蜂巢（NHC）半导体工艺与AI气味算法，突破了传统催化燃烧式传感器易中毒、寿命短的技术瓶颈。不仅能够实现对甲烷、丙烷、氢气等多种可燃气体的24小时不间断监测，还能在气体浓度达到爆炸下限（LEL）的极低百分比时即刻发出预警。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '安全防护',
                text: [
                  "产品采用高强度隔爆外壳，抗干扰能力强。确保在腐蚀性、高粉尘的环境中稳定运行。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: '精准监测',
                text: [
                  "得益于艾感NHC技术带来的极大比表面积，传感器能够加速捕捉气体分子，精准数显泄漏浓度，量化风险等级。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '低误报率',
                text: [
                  "内置自研气味算法，智能识别传感器老化曲线并进行补偿；系统还具备传感器故障自诊断功能。"
                ],
                imgurl: "adv-icon03.png"
              }, {
                title: '灵活供电',
                text: [
                  "支持4-20mA标准信号、RS485及4G/NB-IoT等多种通信方式，可轻松接入现有DCS、PLC系统或搭建无线监测网络。"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '重塑标准',
                text: [
                  "解决了传统传感器易中毒、寿命短、误报率高的问题，推动了气体监测技术从“单一检测”向“智能感知”的跨越"
                ],
                imgurl: "plan011-1.png"
              }, {
                title: '主动防御',
                text: [
                  "系统在气体泄漏初期即刻预警，有效预防爆炸、火灾等重大安全事故，最大程度保障人员生命与企业财产安全"
                ],
                imgurl: "plan011-2.png"
              }, {
                title: '管理升级',
                text: [
                  "所有监测数据、报警记录与设备状态均可实时上传至云端管理平台，自动生成报表，满足安全审计与合规要求"
                ],
                imgurl: "plan011-3.png"
              }
            ],
          }, {
            name: "应用场景",
            imgUrl: "industry-demo.png"
          }, {
            name: "产品参数",
            table: {
              header: ["参数名称", "参数值"],
              body: [
                {"参数名称": "检测气体", "参数值":"甲烷、丙烷、异丁烷等可燃气体"},
                {"参数名称": "检测原理", "参数值":"催化燃烧式"},
                {"参数名称": "检测范围", "参数值":"（3%~100%）LEL"},
                {"参数名称": "报警设定值", "参数值":"限高20%LEL＋限高50%LEL"},
                {"参数名称": "采样方式", "参数值":"扩散式"},
                {"参数名称": "工作方式", "参数值":"系统式"},
                {"参数名称": "显示方式", "参数值":"数码管"},
                {"参数名称": "工作电压", "参数值":"DC24V"},
                {"参数名称": "功率", "参数值":"≤3W"},
                {"参数名称": "进接线口", "参数值":"G3/4螺纹"},
                {"参数名称": "响应时间", "参数值":"≤30s"},
                {"参数名称": "通信方式", "参数值":"RS485"},
                {"参数名称": "调零标定", "参数值":"控制器"},
                {"参数名称": "更改地址", "参数值":"控制器"},
                {"参数名称": "报警音量", "参数值":"70db~115db"},
                {"参数名称": "大气压力", "参数值":"86kPa~106kPa"},
                {"参数名称": "防护等级", "参数值":"IP66"},
                {"参数名称": "防爆级别", "参数值":"Exdb Ⅱ CT6Gb(隔爆型）"},
                {"参数名称": "使用环境", "参数值":"室外使用型"},
                {"参数名称": "外形尺寸", "参数值":"90mm(直径）×68mm(H)"},
                {"参数名称": "整机重量", "参数值":"约1kg"},
              ]
            }
          }
        ]
      }, {
        id: "034",
        name: "具身智能嗅觉系统",
        dec: "具身智能嗅觉系统",
        imgUrl: "machineDog.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [
          {
            name: "方案背景",
            text: ["人工智能感知技术飞速发展演进，视觉与听觉已趋于成熟，而嗅觉感知却长期缺失。气味，是自然界最核心的信息载体之一，是工业安全、食品管控、环境监测等领域的关键判断依据。传统“电子鼻”受限于识别精度低、环境适应性差，难以满足复杂场景需求，艾感科技将高精度气味感知技术与设备终端深度融合，推出“感知-分析-决策-联动” 一体化的具身智能嗅觉监测系统，赋予具身智能机器人嗅觉功能，使其感知能力更加完整。"]
          }, {
            name: "方案概述",
            text: ["艾感科技具身智能嗅觉监测系统，模拟人类嗅觉系统“感知、判断、响应”的运行逻辑，将气体传感阵列融合AI 气味识别算法、具身交互技术，赋予机器人“移动感知、智能交互、自主决策、场景适配” 的智慧嗅觉监测能力，突破了传统设备固定检测的局限。系统的多维感知模块采用微型化设计，易于集成至巡检机器人、消防机器人、护理机器人、无人机等移动终端，实现动态环境下的实时分析与主动干预。"]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '嗅觉传感器阵列',
                text: [
                  "模拟人类嗅觉受体机制，采用自研仿生嗅觉神经细胞与多模态传感器阵列，实现对挥发性有机物的高灵敏度响应。突破传统传感器交叉敏感性瓶颈，能特异性识别复杂混合气体。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '气味AI计算平台',
                text: [
                  "搭载艾感气味数据库，将原始信号转化为“数字气味指纹”。通过深度学习构建覆盖数千种气味的数据库，支持动态更新与边缘计算，实现毫秒级识别与溯源。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: '闭环决策系统',
                text: [
                  "与具身智能体（如人形机器人、四足机器人、无人机）深度融合，形成“检测—判断—反馈”自动化流程。支持自主巡航、异常报警、数据回传与云端协同。"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '仿生真嗅觉',
                text: [
                  "模拟生物嗅觉机制，实现更接近人类嗅觉神经对气味的理解"
                ],
                imgurl: "plan003-1.png"
              }, {
                title: '高精度识别',
                text: [
                  "灵敏度达ppb级，支持混合气体识别与微量成分检测，复杂环境下稳定运行"
                ],
                imgurl: "plan012-3.png"
              }, {
                title: '全栈自研',
                text: [
                  "从传感器、算法到云平台全程自主研发，提供标准化模块与定制服务，适配多场景"
                ],
                imgurl: "plan012-2.png"
              }
            ]
          }, {
            name: "应用场景",
            imgUrl: "robot-demo.png"
          }
        ]
      }, {
        id: "035",
        name: "便携式电子鼻",
        dec: "便携式电子鼻",
        imgUrl: "elenoseDevice.png",
        styleType: 2,
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        detail: [
          {
            name: "方案概述",
            text: [
              "便携式电子鼻系统（Electronic Nose-1）是一套融合高灵敏度传感与智能AI计算的轻量化气味分析系统。它打破空间限制与固定式监测的场景束缚，一人能轻松提起移动，方便多场景灵活部署。该方案采用MOS与电化学传感器阵列协同监测，然后结合神经网络算法本地化运行，离线也能稳定工作，精准识别气体成分及浓度。支持气路流量控制与信号处理，可快速定性定量分析挥发气体；还支持针对不同监测场景（如工业泄露、食品安全、环境异味），个性化配置传感器组合。适用于实验室、工业在线监测及环境监测等复杂场景。"
            ]
          // }, {
          //   name: "中控展示",
          //   imgUrl: "elenose-demo.png"
          }, {
            name: "内部结构图",
            imgUrl: "elenose-inside.png"
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '动态实时监测',
                text: [
                  "在线监测TVOC/NH3/H2S/等多种气体",
                  "内置显示屏，实时显示数据曲线",
                  "可保存本地近6个月的数据"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: '多功能集成',
                text: [
                  "支持超标、异常预警，预警信息可推送至终端",
                  "自洁式空气过滤反吹技术，持续高效过滤",
                  "具备类别分析、主要气体浓度及变化曲线分析功能"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '运维便捷',
                text: [
                  "数据可视化，网页、小程序随时查看历史记录",
                  "便捷携带，一人即可轻松提起，适合移动场景",
                  "设计坚固，适应恶劣环境条件，延长设备寿命"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '提效降本',
                text: [
                  "不必送检至实验室，现场就能提供气体成分和浓度分析结果，快速决策，提升作业效率。"
                ],
                imgurl: "plan002-2.png"
              }, {
                title: '灵活通用',
                text: [
                  "模块化设计适配多行业场景，一机多用，部署便捷，满足手持、巡检、挂载等多样化应用需求。"
                ],
                imgurl: "plan002-2.png"
              }, {
                title: '精准预警',
                text: [
                  "ppb级灵敏度，能在多种混合气体共存环境下高准确率识别，提前发现变质、泄漏等风险。"
                ],
                imgurl: "plan002-3.png"
              }, {
                title: '数据可信',
                text: [
                  "检测结果实时上传，全程可追溯，为监管、合规与决策提供客观数据支撑，提升管理透明度与公信力。"
                ],
                imgurl: "plan012-2.png"
              }
            ]
          }, {
            name: "产品参数",
            table: {
              header: ["参数名称", "数值"],
              body: [
                {"参数名称": "产品名称", "数值":"便携式电子鼻系统"},
                {"参数名称": "检测气体", "数值":"挥发性有机物（恶臭值OU值）"},
                {"参数名称": "量程", "数值":"0-200ppm"},
                {"参数名称": "分辨率", "数值":"0.1ppm"},
                {"参数名称": "精度", "数值":"≤±5%FS"},
                {"参数名称": "显示方式", "数值":"Web页面和微信小程序"},
                {"参数名称": "远程升级", "数值":"支持"},
                {"参数名称": "供电电源", "数值":"220VAC+10%,-15%：50Hz ±5Hz"},
                {"参数名称": "信号输出", "数值":"有线：RS485标配，4-20mA选配<br>无线：4G选配"},
                {"参数名称": "进气流量", "数值":"（0.8-8）L/min（流量波动≤0.5/min）"},
                {"参数名称": "环境压力", "数值":"86KPa~106KPa"},
                {"参数名称": "监测仪功能", "数值":"恒温恒压处理，过滤隔离装置，有效过滤粉尘和油水"},
                {"参数名称": "预处理配件", "数值":"过滤疏水器：去除液态水分，可更换滤芯流量<br>控制器：保持气体流量稳定<br>采样泵：膜片式抽气泵，流速均匀可调<br>冷凝器：进气温度≤200℃，出气温度：5℃（选配）<br>校准功能：定期自动零点、目标点校正模块（选配）"}
              ]
            }
          }, {
            name: "应用场景",
            imgUrl: "elenose-demo.png"
          }
        ]
      }, {
        // #######################################################
        id: "036",
        name: "热解粒子探测器",
        dec: "热解粒子探测器",
        imgUrl: "Pyrolysis-particle-detector.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [
          {
            name: "方案背景",
            text: [
              "在电力、通信等高价值设施场景，传统火灾探测技术存在滞后性，通常在烟雾或明火出现后才发出警报，此时物质已进入明火或阴燃阶段，错过了最佳干预时机。尤其在特高压变电站电缆沟、数据中心、储能电站等复杂环境中，粉尘、水雾等干扰因素极易导致传统探测器误报，造成误报。因此，行业亟需一种能够在火灾扩散前、物质热解的最初阶段就精准识别隐患的技术，保障安全系统的可靠性。"
            ]
          }, {
            name: "方案概述",
            text: [
              "艾感科技热解离子探测器，是一款聚焦于物质受热分解的最初阶段，能极早期预警火灾的设备。探测器采用主动吸气采样与高精度离子分析技术，能够捕捉到绝缘材料（如PVC、ABS）在异常发热（150℃-220℃）时释放出的纳米级热解离子（粒径小至1-10nm）。通过内置的AI智能算法，探测器对热解离子的数量、粒径分布及温湿度、VOC等多参数进行综合分析，在火灾发生前数小时发出预警，为应急处置提供宝贵的黄金窗口期。"
            ]
          }, {
            name: "核心优势",
            advlist: [
              {
                title: '极早期预警',
                text: [
                  "敏锐感知电线过热、材料老化等隐患释放的亚微米乃至纳米级粒子，远在阴燃和明火出现前预警，改变火灾防控的被动局面。"
                ],
                imgurl: "adv-icon01.png"
              }, {
                title: '抗干扰力强',
                text: [
                  "该探测器对粉尘、水汽、雾霾等干扰物（粒径通常在400-1200nm）具有极强的抗干扰能力。"
                ],
                imgurl: "adv-icon02.png"
              }, {
                title: '主动采样分析',
                text: [
                  "产品采用自适应恒流风扇导流技术，主动将保护区域的空气样本吸入探测腔，确保监测无死角。"
                ],
                imgurl: "adv-icon03.png"
              }, {
                title: '工业级坚固设计',
                text: [
                  "探测器采用多层防护和核心器件隔离技术，具备特制的防腐保护层，确保在恶劣环境中稳定运行。"
                ],
                imgurl: "adv-icon04.png"
              }
            ]
          }, {
            name: "方案价值",
            valuelist:[
              {
                title: '打破被动防控',
                text: [
                  "在火灾萌芽阶段即预警，为人员疏散和故障排查提供充裕时间，避免数据中心、核电站等高价值场所的数据丢失。"
                ],
                imgurl: "plan002-2.png"
              }, {
                title: '提升管理效能',
                text: [
                  "极低的误报率消除了频繁的无效警报和应急演练，提升了安全管理系统的公信力。"
                ],
                imgurl: "plan002-2.png"
              }, {
                title: '推动技术升级',
                text: [
                  "艾感科技热解离子探测器，攻克了纳米级离子探测与AI分析技术，提升了关键基础设施安全等级。"
                ],
                imgurl: "plan002-3.png"
              }
            ]
          }, {
            name: "产品对比",
            table: {
              header: ["项目", "热解粒子式探测器", "传统感烟探测器（光电/离子）"],
              body: [
                {"项目": "探测对象", "热解粒子式探测器":"不可见的热解粒子（纳米级）", "传统感烟探测器（光电/离子）":"可见的烟雾颗粒（微米级）"},
                {"项目": "探测阶段", "热解粒子式探测器":"过热阶段(火灾初期，尚未阴燃或明火)", "传统感烟探测器（光电/离子）":"阴燃或明火阶段(火灾已发生)"},
                {"项目": "响应时间", "热解粒子式探测器":"极早，<br>可在事故发生前数十分钟甚至数小时报警", "传统感烟探测器（光电/离子）":"较晚，火灾已经形成"},
                {"项目": "应用场景", "热解粒子式探测器":"预防性监控，如配电柜、电缆桥架、数据中心", "传统感烟探测器（光电/离子）":"蓝牙BLE(平均3秒完成)"},
                {"项目": "优点", "热解粒子式探测器":"超早期预警，为排查和处置提供宝贵时间", "传统感烟探测器（光电/离子）":"技术成熟，成本相对较低，对可见烟敏感"},
              ]
            }
          }, {
            name: "产品参数",
            table: {
              header: ["参数名称", "参数值"],
              body: [
                {"参数名称": "工作电源", "参数值":"12V DC，纹波＜100mv"},
                {"参数名称": "功耗", "参数值":"＜5W"},
                {"参数名称": "环境响应时间", "参数值":"≤3S"},
                {"参数名称": "数据响应时间", "参数值":"1S"},
                {"参数名称": "通信总线", "参数值":"RS485"},
                {"参数名称": "通讯接口", "参数值":"XH2.54 4Pin"},
                {"参数名称": "功耗", "参数值":"≤3W"},
                {"参数名称": "固态颗粒物测量范围", "参数值":"检测粒子：PM1.0<br>最大量程：2000ug/m³<br>"+
                                                          "分辨率：1ug/m³ -10℃~60℃<br>最小分辨粒径：0.3um"},
                {"参数名称": "TVOC气体测量范围", "参数值":"量程：0 10000PPB<br>分辨率：1PPB"},
                {"参数名称": "温度测量范围", "参数值":"量程：-30℃~125℃<br>测量精度：±0.3℃"},
                {"参数名称": "湿度测量范围", "参数值":"量程：0 100%RH<br>测量精度：±3%RH"},
                {"参数名称": "外壳尺寸", "参数值":"长100MM宽100MM高42MM"},
                {"参数名称": "外壳材质", "参数值":"ABS"},
                {"参数名称": "设备设计寿命", "参数值":"5年"},
                {"参数名称": "使用环境温度", "参数值":"-10℃~60℃"},
                {"参数名称": "适应环境湿度", "参数值":"0~99%RH 不凝露"},
              ]
            }
          }, {
            name: "应用场景",
            imgUrl: "Pyrolysis-demo.png"
          }
        ]
      }
    ]
  }, {
    type: '标准化气体',
    id: "4",
    data: [
      {
        id: "041",
        name: "静态测试平台",
        dec: "静态测试平台",
        imgUrl: "testBox.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [{
          name: "方案背景",
          text: [
            "具身智能嗅觉系统（电子鼻）作为气体监测的核心技术载体，性能的稳定性与数据的可靠性直接决定了应用效果。当前，其研发和生产测试环节面临 “无标准化测试基准、性能验证不全面、场景适配性难量化” 的问题。传统嗅觉系统测试多依赖人工操作或简易气室，易受环境温湿度、混合气体干扰、设备移动状态等变量影响，导致测试数据不准确、算法与硬件脱节、难以实现软硬件协同的快速迭代。"
          ]
        }, {
          name: "方案概述",
          text: [
            "艾感科技嗅觉测试系统含静态和动态双平台。静态测试平台采用“模块化硬件+一体化软件”的架构设计，为嗅觉传感器研发、电子鼻设备生产及算法开发提供标准化、自动化测试环境。硬件端构建高密封性、精确控湿的静态顶空测试腔，配合高精度流量控制器，精准配比与供给目标气体；软件端集成实时波形监控、特征值计算、模式识别建模等功能，支持数据实时采集分析，界面友好直观。"
          ]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: '标准化测试环境',
              text: [
                "精密气路设计与严格的环境参数一致性控制，消除外界干扰，提升测试数据的可信度。"
              ],
              imgurl: "adv-icon01.png"
            }, {
              title: '操作便捷',
              text: [
                "内置机器学习算法，用户可直接在软件内完成数据清洗、特征选择、模型训练，灵活部署到硬件设备。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '可视化交互',
              text: [
                "UI界面简洁直观，功能模块区域化分布，方便实时观察传感器电阻变化波形。"
              ],
              imgurl: "adv-icon03.png"
            }, {
              title: '智能辅助',
              text: [
                "支持通过通信协议直接修改硬件加热模式与采样速率，满足不同传感器的特定工作条件需求。"
              ],
              imgurl: "adv-icon04.png"
            }
          ]
        }, {
          name: "产品参数",
          table: {
            header: ["参数名称", "数值"],
            body: [
              {"参数名称": "产品名称", "数值":"静态测试平台"},
              {"参数名称": "型号", "数值":"AETC-Y36"},
              {"参数名称": "内部容积(L)", "数值":"36"},
              {"参数名称": "箱体尺寸(mm)", "数值":"420*320*320"},
              {"参数名称": "材质", "数值":"亚克力"},
              {"参数名称": "电源输入", "数值":"AC 220 V, 50 Hz"},
              {"参数名称": "电源输出", "数值":"DC 12 V, 12.5 A(Max)"},
              {"参数名称": "内部混气风机", "数值":"2个"},
              {"参数名称": "内部通讯接口", "数值":"USB/485(选配)"},
              {"参数名称": "进气方式", "数值":"注射器(选配)<br>蒸发器(选配)<br>进气管(选配)"},
              {"参数名称": "气敏元件测试板", "数值":"选配"},
              {"参数名称": "测试软件", "数值":"选配"},
              {"参数名称": "测试电脑", "数值":"选配"},
              {"参数名称": "管道进气系统", "数值":"选配"},
            ]
          }
        }, {
          name: "应用场景",
          imgUrl: "static-test-demo.png"
        }]
      }, {
        id: "042",
        name: "动态测试平台",
        dec: "动态测试平台",
        imgUrl: "dynamic-testBox.png",
        // href: "https://www.aisensing.cn/PDF/艾感科技_NHC-5A_小量程氢气传感器_技术手册_V1.1.pdf",
        styleType: 2,
        detail: [{
          name: "方案背景",
          text: [
            "具身智能嗅觉系统（电子鼻）作为气体监测的核心技术载体，性能的稳定性与数据的可靠性直接决定了应用效果。当前，其研发和生产测试环节面临 “无标准化测试基准、性能验证不全面、场景适配性难量化” 的问题。传统嗅觉系统测试多依赖人工操作或简易气室，易受环境温湿度、混合气体干扰、设备移动状态等变量影响，导致测试数据不准确、算法与硬件脱节、难以实现软硬件协同的快速迭代。"
          ]
        }, {
          name: "方案概述",
          text: [
            "艾感科技动态测试平台是一套集成了高精度传感器阵列、动态气体稀释系统、智能算法与云端数据管理的综合性解决方案。该平台通过模拟人类嗅觉系统的识别机制，结合动态稀释技术，能够对微量浓度或高浓度的复杂气体样本进行精准检测、识别与量化分析。支持远程在线管控与自动化测试流程，全流程智能化管理，为用户提供稳定可靠的气味数据支持。"
          ]
        }, {
          name: "核心优势",
          advlist: [
            {
              title: '动态稀释',
              text: [
                "稀释倍数覆盖至1000倍以上，高精度MFC多路配气，确保数据的准确性与线性。"
              ],
              imgurl: "adv-icon01.png"
            }, {
              title: '智能嗅辨',
              text: [
                "采用多阵列传感技术，能识别复杂混合气体，区分细微差异。"
              ],
              imgurl: "adv-icon02.png"
            }, {
              title: '远程管控',
              text: [
                "支持电脑与手机双终端操作，用户随时随地查看设备状态、历史数据。"
              ],
              imgurl: "adv-icon03.png"
            }, {
              title: '多场景适用',
              text: [
                "配置与功能灵活扩展，伴热升温功能可定制，模拟不同温度环境要求。"
              ],
              imgurl: "adv-icon04.png"
            }
          ]
        }, {
          name: "产品参数",
          table: {
            header: ["参数名称", "数值"],
            body: [
              {"参数名称": "产品名称", "数值":"动态测试平台"},
              {"参数名称": "型号", "数值":"AEMS-04"},
              {"参数名称": "进出气端口", "数值":"标气进气4端口，载气进气1端口，配气出气1端口(可定制)"},
              {"参数名称": "混气箱尺寸（mm）", "数值":"490*320*260"},
              {"参数名称": "气路材质", "数值":"316L不锈钢/PTFE（可选配）"},
              {"参数名称": "流量范围（可定制）", "数值":"载气流量1 SLM<br>标准气流量 (0-500) sccm"},
              {"参数名称": "稀释比", "数值":"1:1～1:1000"},
              {"参数名称": "稳定时间", "数值":"<10s"},
              {"参数名称": "配气湿度", "数值":"(0-90)%RH可调"},
              {"参数名称": "流量精度与重复性", "数值":"±0.5% F.S."},
              {"参数名称": "通讯控制", "数值":"USB连接电脑，Modbus-RTU通讯调控"},
              {"参数名称": "测试腔容积", "数值":"0.5/1 L 等，可根据客户需求选配定制"},
              {"参数名称": "气敏元件测试基座", "数值":"选配定制"},
              {"参数名称": "测试软件", "数值":"选配"},
              {"参数名称": "测试控制电脑", "数值":"选配"},
            ]
          }
        }, {
          name: "应用场景",
          imgUrl: "static-test-demo.png"
        }]
      }
    ]
  }]

export default { 
  productList, lastNews, oldNews, jobList, footLinkList, 
  intellectualList, honorList, aqiList, companyDetail, 
  teamlist, abilitylist, technologylist, placelist, aboutlist, 
  companyTimelist, partnerlist, videolist, planList
}